/* eslint-disable unicode-bom */
import React, { useState, useMemo, useRef } from 'react';
import './App.css';
import './estilos/Documentos.css';
import './estilos/Tablas.css';
import './estilos/Modales.css';
import './estilos/Pestañas.css';
import './estilos/Secciones.css';
import './estilos/BarraAccionesSeleccion.css';
import BarraAccionesSeleccion from './componentes/subcontratos-materiales/BarraAccionesSeleccion';
import Dashboard from './componentes/subcontratos-materiales/Dashboard';
import api from './servicios/api';
import subcontratosService from './servicios/subcontratosService';
import seccionesSubcontratosService from './servicios/seccionesSubcontratosService';
import seccionesMaterialesService from './servicios/seccionesMaterialesService';
import equipoService from './servicios/equipoService';
import authService from './servicios/authService';
import * as materialesService from './servicios/materialesService';
import documentosMaterialesService from './servicios/documentosMaterialesService';
import certificadosService from './servicios/certificadosService';
import { obtenerActividadesKpi, invalidarCachePrograma } from './servicios/programaService';
import plantillasNombresService from './servicios/plantillasNombresService';
import Login from './componentes/compartidos/Login';
import AvisoActualizacion from './componentes/compartidos/AvisoActualizacion';
import useDebounce from './hooks/useDebounce';
import useVersionCheck from './hooks/useVersionCheck';
import { MatrizRecepcion, ProgresoRecepcion, RutaCriticaRecepcion, RecepcionObra } from './recepcion';
import { MatrizPrograma, DashboardPrograma, ProgresoPrograma } from './programa';
import { DashboardCalidad, MatrizCalidad, ObservacionesCalidad, SeguimientoCalidad, RegistrosCalidad } from './calidad';
import Sidebar from './componentes/compartidos/Sidebar';
import TabAyuda from './componentes/compartidos/TabAyuda';
import TabProyecto from './componentes/proyecto/TabProyecto';
import TabConfiguracion from './componentes/proyecto/TabConfiguracion';
import TabProgreso from './componentes/subcontratos-materiales/TabProgreso';
import TabResumenProyecto from './componentes/proyecto/TabResumenProyecto';
import TabDocumentos from './componentes/subcontratos-materiales/TabDocumentos';
import TabEquipo from './componentes/proyecto/TabEquipo';
import ModalProcesoSubcontrato from './componentes/subcontratos-materiales/ModalProcesoSubcontrato';
import ModalProcesoMaterial from './componentes/subcontratos-materiales/ModalProcesoMaterial';
import TabMatrizMateriales from './componentes/subcontratos-materiales/TabMatrizMateriales';
import TabMatrizSubcontrato from './componentes/subcontratos-materiales/TabMatrizSubcontrato';
import AdminPanel from './componentes/admin/AdminPanel';
import './estilos/AdminPanel.css';
import DashboardGlobal from './componentes/global/DashboardGlobal';
import ModalNuevoProyecto from './componentes/proyecto/ModalNuevoProyecto';
import TabProyectosEquipo from './componentes/global/TabProyectosEquipo';
import TabGlobalEquipo from './componentes/global/TabGlobalEquipo';
import { normalizarPartidas, construirActMapPrograma, obtenerHojasProgramaDedup } from './componentes/subcontratos-materiales/SelectorPartidasPrograma';


// Función para obtener un color único para cada miembro del equipo
const getAvatarColor = (index) => {
  const colors = [
    'linear-gradient(135deg, #10b981 0%, #059669 100%)', // Verde
    'linear-gradient(135deg, #374151 0%, #374151 100%)', // Azul
    'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', // Violeta
    'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', // Rojo
    'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', // Naranja
    'linear-gradient(135deg, #ec4899 0%, #db2777 100%)', // Rosa
    'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)', // Turquesa
    'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', // Índigo
    'linear-gradient(135deg, #84cc16 0%, #65a30d 100%)', // Lima
    'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)', // Cian
  ];
  return colors[index % colors.length];
};

function App() {
  // Estado para mostrar/ocultar el formulario de configuración de días
  const [showConfigDays, setShowConfigDays] = useState(false);
  
  // Estado para mostrar/ocultar el formulario de agregar subcontratos
  const [showTaskForm, setShowTaskForm] = useState(false);
  
  // Estado para edición de sección
  const [editSectionId, setEditSectionId] = useState(null);
  const [editSectionName, setEditSectionName] = useState('');
  const [isSavingSection, setIsSavingSection] = useState(false);
  const [sectionSaveError, setSectionSaveError] = useState(null);
  
  // Estado para mostrar el lápiz solo en hover
  
  // Estado para edición en línea de subcontratos
  const [editTaskId, setEditTaskId] = useState(null);
  const [editFields, setEditFields] = useState({ madeBy: '', specialty: '', text: '', dueDate: '', partidaPrograma: [] });
  const [editTaskModoPrograma, setEditTaskModoPrograma] = useState(false);

  // Estado para loading al guardar procesos
  const [isSavingProcess, setIsSavingProcess] = useState(false);
  const [isSavingMaterialProcess, setIsSavingMaterialProcess] = useState(false);
  
  // Estados para loading al completar subcontratos y materiales
  const [isCompletingTask, setIsCompletingTask] = useState(false);
  const [isCompletingMaterial, setIsCompletingMaterial] = useState(false);
  
  // Estados para loading al revertir procesos
  const [isRevertingProcess, setIsRevertingProcess] = useState(false);
  const [isRevertingMaterialProcess, setIsRevertingMaterialProcess] = useState(false);

  // Iniciar edición de sección
  const startEditSection = (section) => {
    setEditSectionId(section.id);
    setEditSectionName(section.name);
  };

  // Guardar edición de sección
  const saveEditSection = async (sectionId) => {
    if (isSavingSection) return; // Evitar múltiples guardados simultáneos
    
    const oldSectionName = sections.find(s => s.id === sectionId)?.name;
    
    // Validar que el nombre no esté vacío
    if (!editSectionName || !editSectionName.trim()) {
      setSectionSaveError('El nombre de la sección no puede estar vacío');
      return;
    }
    
    // Si el nombre no cambió, solo cerrar el modo edición
    if (oldSectionName === editSectionName.trim()) {
      setEditSectionId(null);
      return;
    }
    
    setIsSavingSection(true);
    setSectionSaveError(null);
    
    try {
      // Actualizar en el backend
      await seccionesSubcontratosService.actualizarSeccion(sectionId, {
        nombre: editSectionName.trim()
      });

      // Actualizar el nombre de la sección en el estado local
      setSections((prev) => prev.map(s => 
        s.id === sectionId ? { ...s, name: editSectionName.trim() } : s
      ));
      
      // Actualizar las subcontratos que tienen esta especialidad
      if (oldSectionName && oldSectionName !== editSectionName.trim()) {
        setTasks((prev) => prev.map(t => 
          t.specialty === oldSectionName ? { ...t, specialty: editSectionName.trim() } : t
        ));
      }
      
      // Recargar documentos para reflejar cambio de especialidad
      await cargarDocumentos();
      
      setEditSectionId(null);
      
      // Mostrar mensaje de éxito brevemente
      setTimeout(() => {
        setSectionSaveError(null);
      }, 3000);
      
    } catch (error) {
      console.error('❌ Error al guardar sección:', error);
      const mensajeError = error.mensaje || error.error || 'Error al actualizar la sección. Inténtalo de nuevo.';
      setSectionSaveError(mensajeError);
      
      // Limpiar error después de 5 segundos
      setTimeout(() => {
        setSectionSaveError(null);
      }, 5000);
    } finally {
      setIsSavingSection(false);
    }
  };

  // Cancelar edición de sección
  const cancelEditSection = () => {
    setEditSectionId(null);
  };

  // Iniciar edición de subcontrato
  const startEditTask = (task) => {
    setEditTaskId(task.id);
    setEditFields({
      madeBy: task.madeBy,
      specialty: task.specialty,
      text: task.text,
      dueDate: task.dueDate ? new Date(task.dueDate).toISOString().split('T')[0] : '',
      partidaPrograma: normalizarPartidas(task.partidaPrograma)
    });
    setEditTaskModoPrograma(normalizarPartidas(task.partidaPrograma).length > 0);
  };

  // Abre la edición de un subcontrato "Pendiente" directamente en modo "Desde Programa"
  // para que el usuario elija la partida (y/o sección) que falta resolver.
  const resolverTaskPendiente = (task) => {
    startEditTask(task);
    setEditTaskModoPrograma(true);
    if (actividadesSubcontrato.length === 0) {
      obtenerActividadesKpi().then(acts => {
        setActividadesSubcontrato(obtenerHojasProgramaDedup(acts));
        setActMapPrograma(construirActMapPrograma(acts));
      });
    }
  };

  // Guardar edición de subcontrato
  const saveEditTask = async (taskId) => {
    try {
      // Actualizar en el backend
      const datosActualizados = {
        texto: editFields.text,
        hechoPor: editFields.madeBy,
        especialidad: editFields.specialty,
        fechaEntrega: editFields.dueDate,
        partidaPrograma: editFields.partidaPrograma,
        pendiente: false
      };

      await subcontratosService.actualizarSubcontrato(taskId, datosActualizados);

      // Actualizar estado local
      setTasks((prev) => prev.map((t) => {
        if (t.id === taskId) {
          // Si se editó la fecha de inicio de partida, recalcula los procesos de manera secuencial
          let updated = { ...t, ...editFields, pendiente: false };
          if (editFields.dueDate !== t.dueDate) {
            const processDates = calculateAllProcessDates(editFields.dueDate);
            updated = {
              ...updated,
              inicio: processDates.inicio,
              envios: processDates.envios,
              comparativo: processDates.comparativo,
              negociacion: processDates.negociacion,
              precalificacion: processDates.precalificacion,
              contratoFirmado: processDates.contratoFirmado
            };
          }
          return updated;
        }
        return t;
      }));
      
      setEditTaskId(null);
    } catch (error) {
      console.error('Error al guardar edición de subcontrato:', error);

      // Verificar error 403 de múltiples formas posibles
      const status = error.response?.status || error.status;
      const esError403 = status === 403;

      // Manejo especial para error 403 (sin permisos)
      if (esError403) {
        const data = error.response?.data || error.data || {};
        const adminInfo = data.administrador || 'el administrador';
        const mensaje = data.mensaje || 'No tienes permisos para modificar fechas';

        const alertMessage = `🚫 Acceso Denegado\n\n${mensaje}\n\n✅ Contacta a: ${adminInfo}`;
        alert(alertMessage);
      } else {
        const mensajeError = error.response?.data?.mensaje || error.mensaje || error.error || error.message || 'Error desconocido';
        alert('❌ Error al guardar los cambios: ' + mensajeError);
      }
    }
  };

  // Cancelar edición de subcontrato
  const cancelEditTask = () => {
    setEditTaskId(null);
    setEditTaskModoPrograma(false);
  };

  // Nota: Los correos ahora se envían via backend usando Resend (benriveros@gestracoo.com)

    // Función para generar el HTML de la tabla de ruta crítica
    const generarTablaHTML = (tasks, nombreProyecto = '') => {
      const processNames = {
        'envios': 'Envíos',
        'comparativo': 'Comparativo',
        'negociacion': 'Negociación',
        'precalificacion': 'Pre-calificación',
        'contratoFirmado': 'Contrato Firmado',
        'dueDate': 'Inicio de Partida'
      };

      const generarBadge = (daysLeft) => {
        let label, bg, color;
        if (daysLeft <= 0) { label = 'VENCIDO'; bg = '#1a1a1a'; color = '#fff'; }
        else if (daysLeft <= 3) { label = 'CRITICO'; bg = '#fef2f2'; color = '#dc2626'; }
        else if (daysLeft <= 7) { label = 'ALTO'; bg = '#fff7ed'; color = '#ea580c'; }
        else if (daysLeft <= 14) { label = 'MEDIO'; bg = '#fefce8'; color = '#ca8a04'; }
        else { label = 'BAJO'; bg = '#f0fdf4'; color = '#16a34a'; }
        return `<span style="padding:3px 8px;border-radius:12px;font-size:11px;font-weight:700;background:${bg};color:${color};">${label}</span>`;
      };

      const cs = 'padding:8px;font-size:12px;border-bottom:1px solid #eee;'; // cell style
      let filasHTML = '';
      tasks.forEach((task, index) => {
        const daysLeft = task.daysUntilDue;
        const nextProcess = processNames[task.nextProcess] || task.nextProcess;
        const rowBg = index % 2 === 0 ? '#fff' : '#fafafa';
        const dc = daysLeft <= 3 ? '#dc2626' : daysLeft <= 7 ? '#ea580c' : '#1a1a1a';

        filasHTML += `<tr style="background:${rowBg};">
          <td style="${cs}text-align:center;color:#999;">${index + 1}</td>
          <td style="${cs}">${task.responsable?.nombre || '-'}</td>
          <td style="${cs}">${task.specialty}</td>
          <td style="${cs}font-weight:600;">${task.text}</td>
          <td style="${cs}text-align:center;font-weight:700;color:${dc};">${daysLeft}d</td>
          <td style="${cs}color:#374151;font-weight:600;">${nextProcess}</td>
          <td style="${cs}text-align:center;">${formatDate(task.dueDate)}</td>
          <td style="${cs}text-align:center;">${generarBadge(daysLeft)}</td>
        </tr>`;
      });

      const hs = 'padding:8px;font-size:11px;font-weight:600;color:#fff;text-transform:uppercase;'; // header style
      return `
      <div style="margin-bottom:24px;">
        <p style="font-size:16px;font-weight:700;color:#1a1a1a;margin:0 0 8px 0;"><span style="color:#374151;">■</span> SubContratos <span style="background:#f9fafb;color:#374151;font-size:11px;padding:2px 8px;border-radius:10px;">${tasks.length}</span></p>
        <table style="width:100%;border-collapse:collapse;border:1px solid #e5e7eb;font-family:Arial,sans-serif;">
          <thead>
            <tr style="background:#111827;">
              <th style="${hs}text-align:center;">#</th>
              <th style="${hs}">Resp.</th>
              <th style="${hs}">Espec.</th>
              <th style="${hs}">Subcontrato</th>
              <th style="${hs}text-align:center;">Plazo</th>
              <th style="${hs}">Prox. Proc.</th>
              <th style="${hs}text-align:center;">Inicio</th>
              <th style="${hs}text-align:center;">Estado</th>
            </tr>
          </thead>
          <tbody>${filasHTML}</tbody>
        </table>
      </div>`;
    }

    // Generar tabla HTML de Materiales para el correo
    const generarTablaMaterialesHTML = (materials, nombreProyecto = '') => {
      const processNamesMateriales = {
        'cubicacion': 'Cubicación',
        'revCubicacion': 'Rev Cubicación',
        'solped': 'Solped',
        'ocAprobada': 'OC Aprobada',
        'materialEnObra': 'Material en Obra',
        'dueDate': 'Inicio de Partida'
      };

      const generarBadge = (daysLeft) => {
        let label, bg, color;
        if (daysLeft <= 0) { label = 'VENCIDO'; bg = '#1a1a1a'; color = '#fff'; }
        else if (daysLeft <= 3) { label = 'CRITICO'; bg = '#fef2f2'; color = '#dc2626'; }
        else if (daysLeft <= 7) { label = 'ALTO'; bg = '#fff7ed'; color = '#ea580c'; }
        else if (daysLeft <= 14) { label = 'MEDIO'; bg = '#fefce8'; color = '#ca8a04'; }
        else { label = 'BAJO'; bg = '#f0fdf4'; color = '#16a34a'; }
        return `<span style="padding:3px 8px;border-radius:12px;font-size:11px;font-weight:700;background:${bg};color:${color};">${label}</span>`;
      };

      const cs = 'padding:8px;font-size:12px;border-bottom:1px solid #eee;';
      let filasHTML = '';
      materials.forEach((material, index) => {
        const daysLeft = material.daysUntilDue;
        const nextProcess = processNamesMateriales[material.nextProcess] || material.nextProcess;
        const rowBg = index % 2 === 0 ? '#fff' : '#fafafa';
        const dc = daysLeft <= 3 ? '#dc2626' : daysLeft <= 7 ? '#ea580c' : '#1a1a1a';

        filasHTML += `<tr style="background:${rowBg};">
          <td style="${cs}text-align:center;color:#999;">${index + 1}</td>
          <td style="${cs}">${material.responsable?.nombre || '-'}</td>
          <td style="${cs}font-weight:600;">${material.text}</td>
          <td style="${cs}">${material.specialty || '-'}</td>
          <td style="${cs}text-align:center;font-weight:700;color:${dc};">${daysLeft}d</td>
          <td style="${cs}color:#374151;font-weight:600;">${nextProcess}</td>
          <td style="${cs}text-align:center;">${formatDate(material.nextProcessDate)}</td>
          <td style="${cs}text-align:center;">${formatDate(material.dueDate)}</td>
          <td style="${cs}text-align:center;">${generarBadge(daysLeft)}</td>
        </tr>`;
      });

      const hs = 'padding:8px;font-size:11px;font-weight:600;color:#fff;text-transform:uppercase;';
      return `
      <div style="margin-bottom:24px;">
        <p style="font-size:16px;font-weight:700;color:#1a1a1a;margin:0 0 8px 0;"><span style="color:#374151;">■</span> Materiales <span style="background:#f9fafb;color:#374151;font-size:11px;padding:2px 8px;border-radius:10px;">${materials.length}</span></p>
        <table style="width:100%;border-collapse:collapse;border:1px solid #e5e7eb;font-family:Arial,sans-serif;">
          <thead>
            <tr style="background:#111827;">
              <th style="${hs}text-align:center;">#</th>
              <th style="${hs}">Resp.</th>
              <th style="${hs}">Material</th>
              <th style="${hs}">Espec.</th>
              <th style="${hs}text-align:center;">Plazo</th>
              <th style="${hs}">Prox. Proc.</th>
              <th style="${hs}text-align:center;">Fecha Proc.</th>
              <th style="${hs}text-align:center;">Inicio</th>
              <th style="${hs}text-align:center;">Estado</th>
            </tr>
          </thead>
          <tbody>${filasHTML}</tbody>
        </table>
      </div>`;
    }

  const [tasks, setTasks] = useState([]);
  const [completedTasks, setCompletedTasks] = useState([]);
  const [taskText, setTaskText] = useState('');
  const [madeBy, setMadeBy] = useState('Subcontratado');
  const [specialty, setSpecialty] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [taskResponsable, setTaskResponsable] = useState('');
  const [partidaPrograma, setPartidaPrograma] = useState([]);
  const [modoDesdePrograma, setModoDesdePrograma] = useState(false);
  const [actividadesSubcontrato, setActividadesSubcontrato] = useState([]);
  // Mapa { wbsCode: actividad } del Programa completo (incl. nodos padre), usado para
  // derivar el grupo WBS nivel 2 al elegir una partida "Desde Programa" (subcontratos y materiales).
  const [actMapPrograma, setActMapPrograma] = useState({});
  const [nombresPlantillas, setNombresPlantillas] = useState({ subcontratos: [], materiales: [] });
  const [nombresPlantillasCargados, setNombresPlantillasCargados] = useState(false);
  const [mostrarSugerenciasSubcontrato, setMostrarSugerenciasSubcontrato] = useState(false);
  const [mostrarSugerenciasMaterial, setMostrarSugerenciasMaterial] = useState(false);
  const [sections, setSections] = useState([]);

  // Estados para secciones de materiales (independientes)
  const [materialSections, setMaterialSections] = useState([]);

  const [activeTab, setActiveTabState] = useState(
    () => {
      const guardado = localStorage.getItem('activeTab');
      // Compatibilidad: el módulo "certificaciones-*" se renombró a "recepcion-*".
      return guardado && guardado.startsWith('certificaciones-')
        ? guardado.replace('certificaciones-', 'recepcion-')
        : (guardado || 'matriz');
    }
  );
  const setActiveTab = (tab) => {
    localStorage.setItem('activeTab', tab);
    setActiveTabState(tab);
  };
  // Recuerda si el usuario venía navegando dentro de "Vista Global" para que,
  // al abrir Configuración (una pestaña compartida entre ambos contextos), la
  // barra lateral siga mostrando la sección VISTA GLOBAL en vez de volver a la
  // navegación normal de un proyecto específico.
  const [vinoDeVistaGlobal, setVinoDeVistaGlobal] = useState(false);
  React.useEffect(() => {
    const tabsVistaGlobal = ['dashboard-global', 'proyectos-equipo', 'global-equipo'];
    if (tabsVistaGlobal.includes(activeTab)) {
      setVinoDeVistaGlobal(true);
    } else if (activeTab !== 'configuracion') {
      setVinoDeVistaGlobal(false);
    }
  }, [activeTab]);
  const [certificadosCompletados, setCertificadosCompletados] = useState([]);
  // Estados para RECEPCIÓN
  const [certificados, setCertificados] = useState([]);
  const [certificadosObra, setCertificadosObra] = useState([]);
  const [seccionesRecepcion, setSeccionesRecepcion] = useState([]);
  const [fechasRecepcion, setFechasRecepcion] = useState({ fechaRecepcionPrograma: '', fechaRecepcionEsperada: '', mesesRecepcion: 0 });
  const [mesesRecepcionObra, setMesesRecepcionObra] = useState({ mesesContractual: 0, mesesProgramado: 0 });
  const [showModal, setShowModal] = useState(false);
  const [selectedStage, setSelectedStage] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [stageFiles, setStageFiles] = useState({});
  const [stageComments, setStageComments] = useState({});
  const [currentComment, setCurrentComment] = useState('');
  const [completedProcesses, setCompletedProcesses] = useState({});
  const [processNoAplica, setProcessNoAplica] = useState(false); // Estado para "No aplica" en subcontratos
  const [precioPresupuestado, setPrecioPresupuestado] = useState(''); // Precio presupuestado para Contrato Firmado
  const [precioCierre, setPrecioCierre] = useState(''); // Precio de cierre para Contrato Firmado
  
  // Id del proyecto activo "vigente": se actualiza de forma síncrona en cada cambio
  // de proyecto para poder descartar respuestas de red que lleguen tarde (de un
  // proyecto que ya no es el seleccionado) y evitar que sobreescriban el estado
  // con datos de otro proyecto (ver handleCambiarProyecto / cargarProyecto).
  const proyectoVigenteRef = useRef(null);

  const [teamMembers, setTeamMembers] = useState([]);
  const [newMemberName, setNewMemberName] = useState('');
  const [newMemberEmail, setNewMemberEmail] = useState('');
  const [newMemberRole, setNewMemberRole] = useState('');
  const [addingMember, setAddingMember] = useState(false);
  const [processDays, setProcessDays] = useState({
    inicio: 3,
    envios: 3,
    comparativo: 5,
    negociacion: 7,
    precalificacion: 4,
    contratoFirmado: 2,
  });
  const [savingConfig, setSavingConfig] = useState(false);
  
  // Estados para configuración de notificaciones automáticas
  // Estados para Matriz de Materiales (independiente)
  const [materiales, setMateriales] = useState([]);
  const [completedMateriales, setCompletedMateriales] = useState([]);
  const [materialText, setMaterialText] = useState('');
  const [materialSpecialty, setMaterialSpecialty] = useState('');
  const [materialDueDate, setMaterialDueDate] = useState('');
  const [materialResponsable, setMaterialResponsable] = useState('');
  const [partidaProgramaMaterial, setPartidaProgramaMaterial] = useState([]);
  const [modoDesdeProgamaMaterial, setModoDesdeProgamaMaterial] = useState(false);
  const [actividadesMaterial, setActividadesMaterial] = useState([]);
  const [completedProcessesMateriales, setCompletedProcessesMateriales] = useState({});
  const [editMaterialId, setEditMaterialId] = useState(null);
  const [editMaterialFields, setEditMaterialFields] = useState({ text: '', specialty: '', dueDate: '', partidaPrograma: [] });
  const [editMatModoPrograma, setEditMatModoPrograma] = useState(false);
  
  // Estados para edición de responsable
  const [editingResponsableTaskId, setEditingResponsableTaskId] = useState(null);
  const [editingResponsableMaterialId, setEditingResponsableMaterialId] = useState(null);
  
  const [showMaterialForm, setShowMaterialForm] = useState(false);
  const [showConfigMateriales, setShowConfigMateriales] = useState(false);
  const [diasProcesosMateriales, setDiasProcesosMateriales] = useState({
    inicio: 7,
    cubicacion: 7,
    revCubicacion: 7,
    solped: 7,
    ocAprobada: 7,
    materialEnObra: 0
  });
  const [savingConfigMateriales, setSavingConfigMateriales] = useState(false);
  
  // Estados para modal de materiales
  const [showMaterialModal, setShowMaterialModal] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [selectedMaterialStage, setSelectedMaterialStage] = useState(null);
  const [materialStageFiles, setMaterialStageFiles] = useState({});
  const [materialStageComments, setMaterialStageComments] = useState({});
  const [currentMaterialComment, setCurrentMaterialComment] = useState('');
  const [materialProcessNoAplica, setMaterialProcessNoAplica] = useState(false); // Estado para "No aplica" en materiales
  const [precioPresupuestadoMaterial, setPrecioPresupuestadoMaterial] = useState(''); // Precio presupuestado para OC Aprobada
  const [precioCierreMaterial, setPrecioCierreMaterial] = useState(''); // Precio de cierre para OC Aprobada
  
  // Estados para documentos cargados desde MongoDB (para pestaña Documentos)
  const [documentosSubcontratos, setDocumentosSubcontratos] = useState([]);
  const [documentosMateriales, setDocumentosMateriales] = useState([]);
  
  // Estados para controlar secciones expandidas/colapsadas en vista documentos
  const [expandedSectionsSubcontratos, setExpandedSectionsSubcontratos] = useState({});
  const [expandedSectionsMateriales, setExpandedSectionsMateriales] = useState({});
  
  // Estados para filtros de subcontratos (Matriz de Subcontratos)
  const [filtrosBusqueda, setFiltrosBusqueda] = useState({
    texto: '',
    especialidad: 'todas',
    estado: 'todos',
    criticos: false,
    pendientes: false,
    proceso: 'todos',
    responsable: 'todos' // Filtro por responsable
  });

  // Debounce para búsqueda de subcontratos - evita filtrar en cada tecla
  const debouncedTextoBusqueda = useDebounce(filtrosBusqueda.texto, 300);
  
  // Estados para filtros de materiales
  const [filtrosMateriales, setFiltrosMateriales] = useState({
    texto: '',
    especialidad: 'todas',
    estado: 'todos',
    criticos: false,
    pendientes: false,
    proceso: 'todos',
    responsable: 'todos' // Filtro por responsable
  });

  // Debounce para búsqueda de materiales
  const debouncedTextoMateriales = useDebounce(filtrosMateriales.texto, 300);
  
  // Estados para selección múltiple (eliminación masiva)
  const [subcontratosSeleccionados, setSubcontratosSeleccionados] = useState(new Set());
  const [materialesSeleccionados, setMaterialesSeleccionados] = useState(new Set());
  const [eliminandoSeleccionados, setEliminandoSeleccionados] = useState(false);
  
  // Estados para información del proyecto
  const [projectName, setProjectName] = useState('');
  const [projectManager, setProjectManager] = useState('');
  const [projectUser, setProjectUser] = useState('');
  const [propietarioEmail, setPropietarioEmail] = useState(''); // Email del propietario
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const { hayActualizacion, recargarAhora } = useVersionCheck();
  const [usuarioActual, setUsuarioActual] = useState(null);
  const [appsVisibles, setAppsVisibles] = useState({ gestracoo: true, recepcion: true, calidad: true });

  // Multi-proyecto
  const [proyectos, setProyectos] = useState(() => authService.obtenerProyectos());
  const [proyectoActivo, setProyectoActivo] = useState(null);
  const [showModalNuevoProyecto, setShowModalNuevoProyecto] = useState(false);
  
  // Estado para mostrar/ocultar formulario de proyecto
  const [showProjectForm, setShowProjectForm] = useState(false);
  const [isEditingProject, setIsEditingProject] = useState(false);
  const [showTeamForm, setShowTeamForm] = useState(false);
  const [, /* setShowAutoNotifications */] = useState(false);
  const [, /* setShowManualNotifications */] = useState(false);
  const [showSavedPassword, setShowSavedPassword] = useState(false);

  // Cargar información del proyecto y estado de login desde localStorage al iniciar
  React.useEffect(() => {
    const verificarAutenticacion = async () => {
      const savedLoginState = localStorage.getItem('isLoggedIn');
      const token = localStorage.getItem('token');
      const usuarioStr = localStorage.getItem('usuario');
      
      // Si hay token y usuario guardados, cargar los datos
      if (savedLoginState === 'true' && token && usuarioStr) {
        setIsLoggedIn(true);
        
        try {
          const usuario = JSON.parse(usuarioStr);
          setUsuarioActual(usuario); // Guardar usuario completo
          
          // Cargar email del usuario
          if (usuario.email) {
            setProjectUser(usuario.email);
          }
          
          // Cargar email del propietario
          try {
            const propietario = await authService.obtenerPropietario();
            if (propietario && propietario.email) {
              setPropietarioEmail(propietario.email);
            }
          } catch (error) {
            console.error('Error al cargar propietario:', error);
          }
          
          // Intentar obtener datos del proyecto desde el backend
          const cargarProyecto = async () => {
            try {
              const perfil = await authService.obtenerPerfil();

              // Multi-proyecto: actualizar lista desde backend (fuente de verdad)
              if (perfil.proyectos) {
                setProyectos(perfil.proyectos);
                localStorage.setItem('proyectos', JSON.stringify(perfil.proyectos));

                // Si el proyecto activo en localStorage ya no existe (fue eliminado), limpiarlo
                const activoId = localStorage.getItem('proyectoActivoId');
                const activoExiste = perfil.proyectos.some(p => (p._id || p.id) === activoId);
                if (activoId && !activoExiste) {
                  localStorage.removeItem('proyectoActivoId');
                }
              }

              const p = perfil.proyectoActivo || perfil.proyecto;
              if (p) {
                proyectoVigenteRef.current = p._id || p.id;
                setProyectoActivo(p);
                authService.cambiarProyectoActivo(p);
                setProjectName(p.nombre);
                setProjectManager(p.manager || '');

                // Cargar configuración de días por proceso si existe
                if (p.diasProcesos) {
                  setProcessDays({
                    inicio: p.diasProcesos.inicio ?? 3,
                    envios: p.diasProcesos.envios ?? 7,
                    comparativo: p.diasProcesos.comparativo ?? 7,
                    negociacion: p.diasProcesos.negociacion ?? 7,
                    precalificacion: p.diasProcesos.precalificacion ?? 7,
                    contratoFirmado: p.diasProcesos.contratoFirmado ?? 7
                  });
                }

                // Cargar configuración de días de materiales si existe
                if (p.diasProcesosMateriales) {
                  setDiasProcesosMateriales({
                    inicio: p.diasProcesosMateriales.inicio ?? 7,
                    cubicacion: p.diasProcesosMateriales.cubicacion ?? 10,
                    revCubicacion: p.diasProcesosMateriales.revCubicacion ?? 7,
                    solped: p.diasProcesosMateriales.solped ?? 5,
                    ocAprobada: p.diasProcesosMateriales.ocAprobada ?? 14,
                    materialEnObra: p.diasProcesosMateriales.materialEnObra ?? 7
                  });
                }

                // Cargar fechas de recepción globales de RECEPCIÓN
                setFechasRecepcion({
                  fechaRecepcionPrograma: p.fechaRecepcionPrograma ? p.fechaRecepcionPrograma.split('T')[0] : '',
                  fechaRecepcionEsperada: p.fechaRecepcionEsperada ? p.fechaRecepcionEsperada.split('T')[0] : '',
                  mesesRecepcion: p.mesesRecepcion ?? 0,
                });
                setMesesRecepcionObra({
                  mesesContractual: p.mesesRecepcionObraContractual ?? 0,
                  mesesProgramado:  p.mesesRecepcionObraProgramada  ?? 0,
                });

                // Cargar configuración de apps visibles
                if (p.appsVisibles) {
                  setAppsVisibles(p.appsVisibles);
                  if (!p.appsVisibles.gestracoo) {
                    const tabsGestracoo = ['dashboard', 'matriz', 'materiales', 'documentos', 'progreso'];
                    setActiveTab(prev => tabsGestracoo.includes(prev) ? 'equipo' : prev);
                  }
                }
              }

              // Redirigir según tipo de usuario al restaurar sesión
              if (perfil.usuario?.tipoUsuario === 'propietario' || perfil.usuario?.tipoUsuario === 'gerente') {
                setActiveTab('dashboard-global');
              } else if (perfil.usuario?.tipoUsuario === 'miembro') {
                setActiveTab('proyecto-resumen');
              }
            } catch (error) {
              console.error('Error al cargar proyecto:', error);
            }
          };
          
          await cargarProyecto();
        } catch (error) {
          console.error('Error al parsear usuario:', error);
        }
      }

      setIsCheckingAuth(false);
    };
    
    verificarAutenticacion();
  }, []);

  // Cargar subcontratos, secciones y miembros del backend cuando el usuario esté autenticado
  React.useEffect(() => {
    const cargarDatosDesdeBackend = async () => {
      if (!isLoggedIn) return;
      
      const token = localStorage.getItem('token');
      if (!token) return;

      // Id del proyecto para el que se está ejecutando esta cadena de carga.
      // Si el usuario cambia de proyecto mientras esta cadena sigue en vuelo,
      // proyectoVigenteRef.current dejará de coincidir con este valor y las
      // respuestas tardías se descartan en vez de sobreescribir el estado.
      let idProyectoDeEstaCarga = proyectoVigenteRef.current;

      try {
        // Cargar perfil del proyecto (incluye fechas de recepción RECEPCIÓN, días de procesos, etc.)
        try {
          const perfil = await authService.obtenerPerfil();

          // Multi-proyecto: actualizar lista desde backend (fuente de verdad)
          if (perfil.proyectos) {
            setProyectos(perfil.proyectos);
            localStorage.setItem('proyectos', JSON.stringify(perfil.proyectos));

            // Si el proyecto activo en localStorage ya no existe (fue eliminado), limpiarlo
            const activoId = localStorage.getItem('proyectoActivoId');
            const activoExiste = perfil.proyectos.some(p => (p._id || p.id) === activoId);
            if (activoId && !activoExiste) {
              localStorage.removeItem('proyectoActivoId');
            }
          }

          const p = perfil.proyectoActivo || perfil.proyecto;
          if (p) {
            idProyectoDeEstaCarga = p._id || p.id;
            proyectoVigenteRef.current = idProyectoDeEstaCarga;
            setProyectoActivo(p);
            authService.cambiarProyectoActivo(p);
            setProjectName(p.nombre);
            setProjectManager(p.manager || '');

            if (p.diasProcesos) {
              setProcessDays({
                inicio: p.diasProcesos.inicio ?? 3,
                envios: p.diasProcesos.envios ?? 7,
                comparativo: p.diasProcesos.comparativo ?? 7,
                negociacion: p.diasProcesos.negociacion ?? 7,
                precalificacion: p.diasProcesos.precalificacion ?? 7,
                contratoFirmado: p.diasProcesos.contratoFirmado ?? 7
              });
            }

            if (p.diasProcesosMateriales) {
              setDiasProcesosMateriales({
                inicio: p.diasProcesosMateriales.inicio ?? 7,
                cubicacion: p.diasProcesosMateriales.cubicacion ?? 10,
                revCubicacion: p.diasProcesosMateriales.revCubicacion ?? 7,
                solped: p.diasProcesosMateriales.solped ?? 5,
                ocAprobada: p.diasProcesosMateriales.ocAprobada ?? 14,
                materialEnObra: p.diasProcesosMateriales.materialEnObra ?? 7
              });
            }

            setFechasRecepcion({
              fechaRecepcionPrograma: p.fechaRecepcionPrograma ? p.fechaRecepcionPrograma.split('T')[0] : '',
              fechaRecepcionEsperada: p.fechaRecepcionEsperada ? p.fechaRecepcionEsperada.split('T')[0] : '',
              mesesRecepcion: p.mesesRecepcion ?? 0,
            });
            setMesesRecepcionObra({
              mesesContractual: p.mesesRecepcionObraContractual ?? 0,
              mesesProgramado:  p.mesesRecepcionObraProgramada  ?? 0,
            });

            if (p.appsVisibles) {
              setAppsVisibles(p.appsVisibles);
            }
          }
        } catch (errPerfil) {
          console.error('⚠️ Error al cargar perfil del proyecto:', errPerfil);
        }

        // Cargar subcontratos activas (no completadas)
        const subcontratosBackend = await subcontratosService.obtenerSubcontratos(false);
        // El proyecto activo pudo haber cambiado mientras esta petición estaba en vuelo:
        // si ya no coincide, esta respuesta quedó obsoleta y no debe aplicarse.
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
        if (subcontratosBackend && subcontratosBackend.length > 0) {
          const subcontratosFormateados = subcontratosBackend.map(t => {
            // Calcular fechas de procesos de manera secuencial si no existen
            const processDates = t.envios 
              ? {
                  inicio: t.inicio,
                  envios: t.envios,
                  comparativo: t.comparativo,
                  negociacion: t.negociacion,
                  precalificacion: t.precalificacion,
                  contratoFirmado: t.contratoFirmado
                }
              : calculateAllProcessDates(t.fechaEntrega);
            
            return {
              id: t._id,
              text: t.texto,
              madeBy: t.hechoPor,
              specialty: t.especialidad,
              dueDate: t.fechaEntrega,
              section: t.seccion,
              responsable: t.responsable,
              partidaPrograma: t.partidaPrograma || null,
              pendiente: t.pendiente || false,
              inicio: processDates.inicio,
              envios: processDates.envios,
              comparativo: processDates.comparativo,
              negociacion: processDates.negociacion,
              precalificacion: processDates.precalificacion,
              contratoFirmado: processDates.contratoFirmado,
            };
          });
          setTasks(subcontratosFormateados);
          
          // Cargar procesos completados desde el backend
          const procesosCompletadosMap = {};
          subcontratosBackend.forEach(t => {
            if (t.procesosCompletados) {
              // Convertir Map a objeto si es necesario
              const procesos = t.procesosCompletados instanceof Map 
                ? Object.fromEntries(t.procesosCompletados)
                : t.procesosCompletados;
              
              Object.entries(procesos).forEach(([etapa, datos]) => {
                const fileKey = `${t._id}-${etapa}`;
                procesosCompletadosMap[fileKey] = {
                  timestamp: datos.marcaTiempo,
                  filesCount: datos.cantidadArchivos || 0,
                  commentsCount: datos.cantidadComentarios || 0,
                  noAplica: datos.noAplica || false,
                  precioPresupuestado: datos.precioPresupuestado,
                  precioCierre: datos.precioCierre
                };
              });
            }
          });
          
          if (Object.keys(procesosCompletadosMap).length > 0) {
            setCompletedProcesses(procesosCompletadosMap);
          }
        }
        
        // Cargar subcontratos completadas desde la colección subcontratoscompletados
        const subcontratosCompletadosBackend = await subcontratosService.obtenerSubcontratosCompletados();
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
        if (subcontratosCompletadosBackend && subcontratosCompletadosBackend.length > 0) {
          const subcontratosCompletadosFormateados = subcontratosCompletadosBackend.map(t => {
            const processDates = t.envios 
              ? {
                  inicio: t.inicio,
                  envios: t.envios,
                  comparativo: t.comparativo,
                  negociacion: t.negociacion,
                  precalificacion: t.precalificacion,
                  contratoFirmado: t.contratoFirmado
                }
              : calculateAllProcessDates(t.fechaEntrega);
            
            return {
              id: t._id,
              text: t.texto,
              madeBy: t.hechoPor,
              specialty: t.especialidad,
              dueDate: t.fechaEntrega,
              section: t.seccion,
              inicio: processDates.inicio,
              envios: processDates.envios,
              comparativo: processDates.comparativo,
              negociacion: processDates.negociacion,
              precalificacion: processDates.precalificacion,
              contratoFirmado: processDates.contratoFirmado,
              completedDate: t.fechaCompletada
            };
          });
          setCompletedTasks(subcontratosCompletadosFormateados);
        }
        
        // Cargar secciones de subcontratos
        const seccionesSubcontratosBackend = await seccionesSubcontratosService.obtenerSecciones();
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
        if (seccionesSubcontratosBackend && seccionesSubcontratosBackend.length > 0) {
          const seccionesFormateadas = seccionesSubcontratosBackend.map(s => ({
            id: s._id,
            name: s.nombre
          }));
          setSections(seccionesFormateadas);
        }
        
        // Cargar secciones de materiales
        const seccionesMaterialesBackend = await seccionesMaterialesService.obtenerSecciones();
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
        if (seccionesMaterialesBackend && seccionesMaterialesBackend.length > 0) {
          const seccionesFormateadas = seccionesMaterialesBackend.map(s => ({
            id: s._id,
            name: s.nombre
          }));
          setMaterialSections(seccionesFormateadas);
        }
        
        // Cargar miembros del equipo
        const miembrosBackend = await equipoService.obtenerMiembros(true);
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
        if (miembrosBackend && miembrosBackend.length > 0) {
          const miembrosFormateados = miembrosBackend.map(m => ({
            id: m._id,
            name: m.nombre,
            email: m.email,
            role: m.cargo,
            cargo: m.cargo, // Agregar cargo también aquí
            usuario: m.usuario, // Incluir referencia al usuario
            notificaciones: m.notificaciones || {},
            dateAdded: new Date(m.createdAt).toLocaleString('es-ES')
          }));
          setTeamMembers(miembrosFormateados);
        }
        
        // Cargar materiales activos
        const materialesBackend = await materialesService.obtenerMateriales();
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
        if (materialesBackend && materialesBackend.length > 0) {
          const materialesFormateados = materialesBackend.map(m => ({
            id: m._id, // Usar _id de MongoDB como id principal (igual que subcontratos)
            text: m.text,
            specialty: m.specialty || '',
            dueDate: m.dueDate,
            responsable: m.responsable, // Incluir responsable populado
            inicio: m.inicio,
            cubicacion: m.cubicacion,
            revCubicacion: m.revCubicacion,
            solped: m.solped,
            ocAprobada: m.ocAprobada,
            materialEnObra: m.materialEnObra || m.dueDate,
            createdAt: m.createdAt,
            partidaPrograma: m.partidaPrograma || null,
            pendiente: m.pendiente || false
          }));
          setMateriales(materialesFormateados);
          
          // Cargar procesos completados de materiales
          const procesosCompletadosMat = {};
          materialesBackend.forEach(m => {
            // Cargar desde el Map procesosCompletados (nuevo formato con detalles)
            if (m.procesosCompletados) {
              const procesos = m.procesosCompletados instanceof Map 
                ? Object.fromEntries(m.procesosCompletados)
                : m.procesosCompletados;
              
              Object.entries(procesos).forEach(([proceso, datos]) => {
                const fileKey = `${m._id}-${proceso}`;
                procesosCompletadosMat[fileKey] = {
                  timestamp: datos.marcaTiempo || new Date().toISOString(),
                  filesCount: datos.cantidadArchivos || 0,
                  commentsCount: datos.cantidadComentarios || 0,
                  noAplica: datos.noAplica || false,
                  precioPresupuestado: datos.precioPresupuestado,
                  precioCierre: datos.precioCierre
                };
              });
            }
            // Fallback: cargar desde completedProcesses (formato antiguo)
            else if (m.completedProcesses) {
              Object.entries(m.completedProcesses).forEach(([proceso, completado]) => {
                if (completado) {
                  const fileKey = `${m._id}-${proceso}`; // Usar _id de MongoDB
                  procesosCompletadosMat[fileKey] = {
                    timestamp: new Date().toISOString(),
                    filesCount: m.stageFiles?.get?.(proceso)?.length || 0,
                    commentsCount: m.stageComments?.has?.(proceso) ? 1 : 0,
                    noAplica: false
                  };
                }
              });
            }
          });
          
          if (Object.keys(procesosCompletadosMat).length > 0) {
            setCompletedProcessesMateriales(procesosCompletadosMat);
          }
        }
        
        // Cargar materiales completados desde la colección dedicada
        const materialesCompletadosBackend = await materialesService.obtenerMaterialesCompletados();
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;

        if (materialesCompletadosBackend && materialesCompletadosBackend.materiales && materialesCompletadosBackend.materiales.length > 0) {
          const materialesCompletadosFormateados = materialesCompletadosBackend.materiales.map(m => ({
            id: m._id, // Usar _id de MongoDB como id
            text: m.texto,
            specialty: m.especialidad || '',
            dueDate: m.fechaInicio,
            inicio: m.procesos?.inicio,
            cubicacion: m.procesos?.cubicacion,
            revCubicacion: m.procesos?.revCubicacion,
            solped: m.procesos?.solped,
            ocAprobada: m.procesos?.ocAprobada,
            completedAt: m.fechaCompletada
          }));
          setCompletedMateriales(materialesCompletadosFormateados);
        } else {
          setCompletedMateriales([]);
        }
        
        // ==================== CARGAR DATOS RECEPCIÓN ====================
        // Cargar certificados activos
        try {
          const certsBackend = await certificadosService.obtenerCertificados();
          if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
          if (certsBackend && certsBackend.length > 0) {
            const certsFormateados = certsBackend.map(c => ({
              id: c._id,
              nombrePartida: c.nombrePartida || '',
              especialidad: c.especialidad || '',
              terminoPartida: c.terminoPartida ? c.terminoPartida.split('T')[0] : '',
              documentos: (c.documentos || []).map(doc => ({
                id: doc._id,
                nombre: doc.nombre || '',
                fechaProgramada: doc.fechaProgramada ? doc.fechaProgramada.split('T')[0] : '',
                fechaEsperada: doc.fechaEsperada ? doc.fechaEsperada.split('T')[0] : '',
                archivos: doc.archivos || [],
                observaciones: doc.observaciones || '',
                completado: doc.completado || false,
                fechaCompletado: doc.fechaCompletado ? doc.fechaCompletado.split('T')[0] : ''
              })),
              responsable: c.responsable ? c.responsable._id || c.responsable : '',
              responsables: (c.responsables || []).map(r => r._id || r),
              responsablesExternos: c.responsablesExternos || []
            }));
            setCertificados(certsFormateados);
          } else {
            setCertificados([]);
          }
        } catch (errCert) {
          console.error('⚠️ Error al cargar certificados RECEPCIÓN:', errCert);
        }

        // Cargar certificados Recepción de Obra
        try {
          const certsObraBackend = await certificadosService.obtenerCertificadosObra();
          if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
          if (certsObraBackend && certsObraBackend.length > 0) {
            const certsObraFormateados = certsObraBackend.map(c => ({
              id: c._id,
              nombrePartida: c.nombrePartida || '',
              especialidad: c.especialidad || '',
              terminoPartida: c.terminoPartida ? c.terminoPartida.split('T')[0] : '',
              documentos: (c.documentos || []).map(doc => ({
                id: doc._id,
                nombre: doc.nombre || '',
                fechaProgramada: doc.fechaProgramada ? doc.fechaProgramada.split('T')[0] : '',
                fechaEsperada: doc.fechaEsperada ? doc.fechaEsperada.split('T')[0] : '',
                archivos: doc.archivos || [],
                observaciones: doc.observaciones || '',
                completado: doc.completado || false,
                fechaCompletado: doc.fechaCompletado ? doc.fechaCompletado.split('T')[0] : ''
              })),
              responsable: c.responsable ? c.responsable._id || c.responsable : '',
              responsables: (c.responsables || []).map(r => r._id || r),
              responsablesExternos: c.responsablesExternos || []
            }));
            setCertificadosObra(certsObraFormateados);
          } else {
            setCertificadosObra([]);
          }
        } catch (errObra) {
          console.error('⚠️ Error al cargar certificados Recepción de Obra:', errObra);
          setCertificadosObra([]);
        }

        // Cargar certificados completados
        try {
          const certsCompBackend = await certificadosService.obtenerCompletados();
          if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
          if (certsCompBackend && certsCompBackend.length > 0) {
            const certsCompFormateados = certsCompBackend.map(c => ({
              id: c._id,
              nombrePartida: c.nombrePartida || '',
              especialidad: c.especialidad || '',
              terminoPartida: c.terminoPartida ? c.terminoPartida.split('T')[0] : '',
              documentos: (c.documentos || []).map(doc => ({
                id: doc._id,
                nombre: doc.nombre || '',
                fechaProgramada: doc.fechaProgramada ? doc.fechaProgramada.split('T')[0] : '',
                fechaEsperada: doc.fechaEsperada ? doc.fechaEsperada.split('T')[0] : '',
                archivos: doc.archivos || [],
                observaciones: doc.observaciones || '',
                completado: doc.completado || false,
                fechaCompletado: doc.fechaCompletado ? doc.fechaCompletado.split('T')[0] : ''
              })),
              fechaReal: c.fechaReal ? c.fechaReal.split('T')[0] : '',
              responsable: c.responsable
                ? (typeof c.responsable === 'object' ? c.responsable.nombre : c.responsable)
                : '',
              responsables: (c.responsables || []).map(r => typeof r === 'object' ? r.nombre : r),
              responsablesExternos: c.responsablesExternos || []
            }));
            setCertificadosCompletados(certsCompFormateados);
          } else {
            setCertificadosCompletados([]);
          }
        } catch (errCertComp) {
          console.error('⚠️ Error al cargar certificados completados RECEPCIÓN:', errCertComp);
        }

        // Cargar secciones RECEPCIÓN
        try {
          const seccionesRecepcionBackend = await certificadosService.obtenerSecciones();
          if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
          if (seccionesRecepcionBackend && seccionesRecepcionBackend.length > 0) {
            const seccionesFormateadas = seccionesRecepcionBackend.map(s => ({
              id: s._id,
              name: s.nombre
            }));
            setSeccionesRecepcion(seccionesFormateadas);
          } else {
            setSeccionesRecepcion([]);
          }
        } catch (errSecCert) {
          console.error('⚠️ Error al cargar secciones RECEPCIÓN:', errSecCert);
        }
        
      } catch (error) {
        console.error('❌ Error al cargar datos desde backend:', error);
      }
    };
    
    cargarDatosDesdeBackend();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  // Cargar documentos desde MongoDB para la pestaña Documentos
  React.useEffect(() => {
    const cargarDocumentosDesdeBackend = async () => {
      if (!isLoggedIn) return;
      
      try {
        // Cargar documentos de subcontratos
        const responseSub = await api.get('/documentos');
        const docsSub = Array.isArray(responseSub.data) ? responseSub.data : [];
        setDocumentosSubcontratos(docsSub);

        // Cargar documentos de materiales
        const proyectoId = localStorage.getItem('proyectoId');
        if (proyectoId) {
          const docsMat = await documentosMaterialesService.obtenerDocumentosProyecto(proyectoId);
          const docsMatArray = Array.isArray(docsMat) ? docsMat : [];
          setDocumentosMateriales(docsMatArray);
        }
      } catch (error) {
        console.error('❌ Error al cargar documentos:', error);
        setDocumentosSubcontratos([]);
        setDocumentosMateriales([]);
      }
    };
    
    cargarDocumentosDesdeBackend();
  }, [isLoggedIn]); // ✅ Solo depende de isLoggedIn - Los documentos persisten aunque se eliminen subcontratos

  // Efecto para cargar configuración de notificaciones desde el backend
  // Función para guardar el proyecto
  const handleSaveProject = async (e) => {
    e.preventDefault();
    
    // Validar que todos los campos estén completos
    if (!projectName.trim() || !projectManager.trim()) {
      alert('⚠️ Por favor completa todos los campos antes de guardar');
      return;
    }
    
    // Validar formato de email
    const emailRegex = /^\S+@\S+\.\S+$/;
    if (!emailRegex.test(projectUser)) {
      alert('⚠️ Por favor ingresa un email válido');
      return;
    }
    
    try {
      // Obtener email original desde localStorage para comparar
      const savedProject = localStorage.getItem('projectData');
      const originalEmail = savedProject ? JSON.parse(savedProject).user : null;
      
      // Si el email cambió, actualizar primero el email
      if (originalEmail && originalEmail !== projectUser) {
        try {
          await authService.cambiarEmail(projectUser);
        } catch (emailError) {
          console.error('Error al cambiar email:', emailError);
          alert('❌ Error al cambiar el email: ' + (emailError.mensaje || emailError.error || 'Email ya registrado'));
          return;
        }
      }
      
      // Actualizar proyecto en el backend
      await authService.actualizarProyecto(projectName, projectManager);
      
      // Guardar los datos del proyecto en localStorage
      const projectData = {
        name: projectName,
        manager: projectManager,
        user: projectUser,
        lastUpdated: new Date().toISOString()
      };
      
      localStorage.setItem('projectData', JSON.stringify(projectData));
      setIsEditingProject(false);
      
      if (originalEmail && originalEmail !== projectUser) {
        alert('✅ Información del proyecto y email actualizados exitosamente. Recuerda usar tu nuevo email para iniciar sesión.');
      } else {
        alert('✅ Información del proyecto guardada exitosamente');
      }
    } catch (error) {
      console.error('Error al guardar proyecto:', error);
      alert('❌ Error al guardar el proyecto: ' + (error.mensaje || error.error || 'Error desconocido'));
    }
  };

  // Función para cerrar sesión
  const handleLogout = () => {
    authService.logout();
    setIsLoggedIn(false);
    setProyectos([]);
    setProyectoActivo(null);
    localStorage.setItem('isLoggedIn', 'false');
  };

  // Expiración de sesión por inactividad: hoy el token dura 30 días sin otro límite,
  // así que se cierra sesión sola en el cliente tras un tramo largo sin uso.
  React.useEffect(() => {
    if (!isLoggedIn) return undefined;

    const INACTIVIDAD_LIMITE_MS = 12 * 60 * 60 * 1000; // 12 horas

    if (!localStorage.getItem('ultimaActividad')) {
      localStorage.setItem('ultimaActividad', Date.now().toString());
    }

    const verificarInactividad = () => {
      const ultimaActividad = parseInt(localStorage.getItem('ultimaActividad'), 10) || Date.now();
      if (Date.now() - ultimaActividad > INACTIVIDAD_LIMITE_MS) {
        handleLogout();
      }
    };

    const interval = setInterval(verificarInactividad, 5 * 60 * 1000); // cada 5 min
    return () => clearInterval(interval);
  }, [isLoggedIn]);

  // Función para actualizar datos del usuario
  const handleActualizarUsuario = async (datos, esPassword = false) => {
    try {
      if (esPassword) {
        // Cambiar contraseña
        await authService.cambiarPassword(datos.passwordActual, datos.passwordNuevo);
      } else {
        // Actualizar perfil
        const resultado = await authService.actualizarPerfil(datos);
        
        // Actualizar estado local
        if (resultado.usuario) {
          setUsuarioActual(resultado.usuario);
          
          // Si se cambió el nombre, actualizar también en projectUser si coincide
          if (datos.nombre && projectUser === usuarioActual?.email) {
            // Mantener el email, solo actualizar el estado del usuario
            const usuarioActualizado = { ...usuarioActual, nombre: datos.nombre };
            setUsuarioActual(usuarioActualizado);
          }
        }
      }
    } catch (error) {
      console.error('Error al actualizar usuario:', error);
      throw error;
    }
  };

  // Función para guardar la configuración de días por proceso
  const handleSaveProcessDays = async () => {
    setSavingConfig(true);
    try {
      const resultado = await authService.actualizarDiasProcesos(processDays);
      
      // Recargar todas las subcontratos para reflejar los cambios
      const subcontratosBackend = await subcontratosService.obtenerSubcontratos();
      
      const subcontratosFormateados = subcontratosBackend.map(t => {
        const processDates = t.envios
          ? {
              inicio: t.inicio,
              envios: t.envios,
              comparativo: t.comparativo,
              negociacion: t.negociacion,
              precalificacion: t.precalificacion,
              contratoFirmado: t.contratoFirmado
            }
          : calculateAllProcessDates(t.fechaEntrega);
        
        return {
          id: t._id,
          text: t.texto,
          madeBy: t.hechoPor,
          specialty: t.especialidad,
          dueDate: t.fechaEntrega,
          section: t.seccion,
          responsable: t.responsable,
          partidaPrograma: t.partidaPrograma || null,
          pendiente: t.pendiente || false,
          inicio: processDates.inicio,
          envios: processDates.envios,
          comparativo: processDates.comparativo,
          negociacion: processDates.negociacion,
          precalificacion: processDates.precalificacion,
          contratoFirmado: processDates.contratoFirmado,
        };
      });
      setTasks(subcontratosFormateados);

      const mensaje = resultado.subcontratosActualizados > 0
        ? `✅ Configuración guardada exitosamente.\n\n${resultado.subcontratosActualizados} subcontratos existentes han sido actualizados con la nueva configuración.`
        : '✅ Configuración guardada exitosamente.\n\nEsta configuración se aplicará a todos los nuevos subcontratos que agregues.';
      
      alert(mensaje);
    } catch (error) {
      console.error('Error al guardar configuración de días:', error);
      
      // Verificar error 403 de múltiples formas posibles
      const status = error.response?.status || error.status;
      const esError403 = status === 403;
      
      
      // Manejo especial para error 403 (sin permisos)
      if (esError403) {
        const data = error.response?.data || error.data || {};
        const adminInfo = data.administrador || 'el administrador';
        const mensaje = data.mensaje || 'No tienes permisos para modificar fechas';
        
        window.alert(`🚫 Acceso Denegado\n\n${mensaje}\n\n✅ Contacta a: ${adminInfo}`);
      } else {
        const mensajeError = error.response?.data?.mensaje || error.mensaje || error.error || error.message || 'Error desconocido';
        window.alert('❌ Error al guardar la configuración: ' + mensajeError);
      }
    } finally {
      setSavingConfig(false);
    }
  };

  // Función para guardar la configuración de días de procesos de materiales
  const handleSaveProcessDaysMateriales = async () => {
    setSavingConfigMateriales(true);
    try {
      const resultado = await authService.actualizarDiasProcesosMateriales(diasProcesosMateriales);
      
      // Recargar todos los materiales para reflejar los cambios
      const materialesBackend = await materialesService.obtenerMateriales();
      
      const materialesFormateados = materialesBackend.map(m => ({
        id: m._id,
        text: m.text,
        specialty: m.specialty || '',
        dueDate: m.dueDate,
        responsable: m.responsable,
        partidaPrograma: m.partidaPrograma || null,
        pendiente: m.pendiente || false,
        inicio: m.inicio,
        cubicacion: m.cubicacion,
        revCubicacion: m.revCubicacion,
        solped: m.solped,
        ocAprobada: m.ocAprobada,
        materialEnObra: m.materialEnObra || m.dueDate,
        createdAt: m.createdAt
      }));
      setMateriales(materialesFormateados);

      const mensaje = resultado.materialesActualizados > 0
        ? `✅ Configuración guardada exitosamente.\n\n${resultado.materialesActualizados} materiales existentes han sido actualizados con la nueva configuración.`
        : '✅ Configuración guardada exitosamente.\n\nEsta configuración se aplicará a todos los nuevos materiales que agregues.';
      
      alert(mensaje);
    } catch (error) {
      console.error('Error al guardar configuración de días de materiales:', error);
      
      // Verificar error 403 de múltiples formas posibles
      const status = error.response?.status || error.status;
      const esError403 = status === 403;
      
      
      // Manejo especial para error 403 (sin permisos)
      if (esError403) {
        const data = error.response?.data || error.data || {};
        const adminInfo = data.administrador || 'el administrador';
        const mensaje = data.mensaje || 'No tienes permisos para modificar fechas';
        
        window.alert(`🚫 Acceso Denegado\n\n${mensaje}\n\n✅ Contacta a: ${adminInfo}`);
      } else {
        const mensajeError = error.response?.data?.mensaje || error.mensaje || error.error || error.message || 'Error desconocido';
        window.alert('❌ Error al guardar la configuración: ' + mensajeError);
      }
    } finally {
      setSavingConfigMateriales(false);
    }
  };


  // Función para calcular todas las fechas de procesos de manera secuencial
  // Función auxiliar para normalizar fechas y evitar problemas de zona horaria
  const normalizarFecha = (fechaString) => {
    if (typeof fechaString === 'string' && fechaString.includes('-') && !fechaString.includes('T')) {
      const [year, month, day] = fechaString.split('-').map(num => parseInt(num));
      return new Date(year, month - 1, day); // Mes es 0-indexado
    }
    return new Date(fechaString);
  };

  const calculateAllProcessDates = (inicioDepartida) => {
    const inicioPartida = normalizarFecha(inicioDepartida);
    
    // Contrato Firmado = Inicio de Partida - días de Contrato Firmado
    const contratoFirmado = new Date(inicioPartida);
    contratoFirmado.setDate(contratoFirmado.getDate() - processDays.contratoFirmado);
    
    // Pre-calificación = Contrato Firmado - días de Pre-calificación
    const precalificacion = new Date(contratoFirmado);
    precalificacion.setDate(precalificacion.getDate() - processDays.precalificacion);
    
    // Negociación = Pre-calificación - días de Negociación
    const negociacion = new Date(precalificacion);
    negociacion.setDate(negociacion.getDate() - processDays.negociacion);
    
    // Comparativo = Negociación - días de Comparativo
    const comparativo = new Date(negociacion);
    comparativo.setDate(comparativo.getDate() - processDays.comparativo);
    
    // Envíos = Comparativo - días de Envíos
    const envios = new Date(comparativo);
    envios.setDate(envios.getDate() - processDays.envios);
    
    // Inicio = Envíos - días de Inicio (primer proceso)
    const inicio = new Date(envios);
    inicio.setDate(inicio.getDate() - processDays.inicio);
    
    return {
      inicio,
      envios,
      comparativo,
      negociacion,
      precalificacion,
      contratoFirmado
    };
  };

  const cargarNombresPlantillas = () => {
    if (nombresPlantillasCargados) return;
    setNombresPlantillasCargados(true);
    plantillasNombresService.obtenerNombresPlantillas()
      .then(setNombresPlantillas)
      .catch(() => setNombresPlantillasCargados(false));
  };

  const addTask = async (e) => {
    e.preventDefault();
    if (!taskText.trim() || !specialty.trim() || !dueDate) {
      alert('⚠️ Por favor completa todos los campos: Descripción, Especialidad y Fecha de Entrega');
      return false;
    }
    
    try {
      // Si la especialidad no existe en las secciones, agregarla automáticamente
      const especialidadTrim = specialty.trim();
      const seccionExiste = sections.some(s => s.name.toLowerCase() === especialidadTrim.toLowerCase());
      
      if (!seccionExiste && especialidadTrim) {
        try {
          const nuevaSeccion = await seccionesSubcontratosService.crearSeccion(especialidadTrim);
          setSections(prev => [...prev, { id: nuevaSeccion._id, name: nuevaSeccion.nombre }]);
        } catch (errorSeccion) {
          // No bloquear la creación del subcontrato si la sección ya existe en el backend
          // (p.ej. desincronización local) u otro error no crítico al crearla.
          console.warn('No se pudo crear la sección automáticamente, se continúa igual:', errorSeccion);
          setSections(prev => prev.some(s => s.name.toLowerCase() === especialidadTrim.toLowerCase())
            ? prev
            : [...prev, { id: `local-${Date.now()}`, name: especialidadTrim }]);
        }
      }
      
      // Calcular todas las fechas de procesos de manera secuencial
      const processDates = calculateAllProcessDates(dueDate);
      
      // Crear subcontrato en el backend
      const nuevoSubcontrato = await subcontratosService.crearSubcontrato({
        text: taskText.trim(),
        madeBy: madeBy,
        specialty: especialidadTrim,
        dueDate: dueDate,
        section: especialidadTrim,
        responsable: taskResponsable || null,
        partidaPrograma: partidaPrograma || null
      });
      
      
      // Agregar al estado local con los datos del backend + datos calculados localmente
      const newTask = {
        id: nuevoSubcontrato._id || Date.now(),
        text: taskText.trim(),
        madeBy: madeBy,
        specialty: especialidadTrim,
        dueDate: dueDate,
        responsable: nuevoSubcontrato.responsable || null,
        partidaPrograma: partidaPrograma || null,
        pendiente: nuevoSubcontrato.pendiente || false,
        inicio: processDates.inicio,
        envios: processDates.envios,
        comparativo: processDates.comparativo,
        negociacion: processDates.negociacion,
        precalificacion: processDates.precalificacion,
        contratoFirmado: processDates.contratoFirmado,
        section: especialidadTrim,
      };

      setTasks((prev) => [newTask, ...prev]);
      setTaskText('');
      setMadeBy('Subcontratado');
      setSpecialty('');
      setDueDate('');
      setTaskResponsable('');
      setPartidaPrograma([]);
      setModoDesdePrograma(false);

      return true;
    } catch (error) {
      console.error('❌ Error al guardar subcontrato:', error);
      
      // Determinar mensaje de error específico
      let mensajeError = '';
      
      if (!error.response && (error.code === 'ERR_NETWORK' || error.message?.includes('Network'))) {
        mensajeError = `🔌 ERROR DE CONEXIÓN

No se puede conectar con el servidor backend.

💡 SOLUCIÓN:
1. Abre una terminal en la carpeta 'backend'
2. Ejecuta: npm start
3. Verifica que aparezca: "Servidor corriendo en http://localhost:5000"
4. Intenta guardar la subcontrato nuevamente`;
      } else if (error.response?.status === 401) {
        mensajeError = `🔐 ERROR DE AUTENTICACIÓN

Tu sesión ha expirado.

💡 SOLUCIÓN:
Por favor, cierra sesión y vuelve a iniciar sesión.`;
      } else if (error.response?.status === 400) {
        const detalle = error.response?.data?.mensaje || 'Datos inválidos';
        mensajeError = `⚠️ ERROR DE VALIDACIÓN

${detalle}

💡 SOLUCIÓN:
Verifica que todos los campos estén completos y correctos.`;
      } else {
        mensajeError = `❌ ERROR AL GUARDAR EL SUBCONTRATO

${error.response?.data?.mensaje || error.message || 'Error desconocido'}

💡 SOLUCIÓN:
1. Verifica que el backend esté corriendo
2. Revisa la consola del navegador (F12) para más detalles
3. Revisa los logs del backend`;
      }

      alert(mensajeError);
      return false;
    }
  };

  // ==================== FUNCIONES AUXILIARES PARA FILTROS ====================
  // Función para obtener el próximo proceso no completado de una subcontrato
  const getNextIncompleteProcess = (task) => {
    const processOrder = ['inicio', 'envios', 'comparativo', 'negociacion', 'precalificacion', 'contratoFirmado'];
    const now = new Date();
    
    for (const processName of processOrder) {
      const fileKey = `${task.id}-${processName}`;
      const isCompleted = completedProcesses[fileKey];
      
      if (!isCompleted) {
        // Este es el próximo proceso no completado
        const processDate = new Date(task[processName]);
        const daysRemaining = Math.ceil((processDate - now) / (1000 * 60 * 60 * 24));
        return {
          processName,
          fecha: task[processName],
          processDate: task[processName],
          daysRemaining
        };
      }
    }
    
    // Si todos los procesos están completados, usar la fecha de inicio de partida
    const dueDateObj = new Date(task.dueDate);
    const daysRemaining = Math.ceil((dueDateObj - now) / (1000 * 60 * 60 * 24));
    return {
      processName: 'dueDate',
      fecha: task.dueDate,
      processDate: task.dueDate,
      daysRemaining
    };
  };

  // Función para obtener el próximo proceso no completado de un material
  const getNextIncompleteMaterialProcess = (material) => {
    const processOrder = ['inicio', 'cubicacion', 'revCubicacion', 'solped', 'ocAprobada', 'materialEnObra'];
    const now = new Date();
    
    for (const processName of processOrder) {
      const fileKey = `${material.id}-${processName}`;
      const isCompleted = completedProcessesMateriales[fileKey];
      
      if (!isCompleted) {
        // Este es el próximo proceso no completado
        const processDate = new Date(material[processName]);
        const daysRemaining = Math.ceil((processDate - now) / (1000 * 60 * 60 * 24));
        return {
          processName,
          fecha: material[processName],
          processDate: material[processName],
          daysRemaining
        };
      }
    }
    
    // Si todos los procesos están completados, usar la fecha de materialEnObra
    const dueDateObj = new Date(material.materialEnObra || material.dueDate);
    const daysRemaining = Math.ceil((dueDateObj - now) / (1000 * 60 * 60 * 24));
    return {
      processName: 'materialEnObra',
      fecha: material.materialEnObra || material.dueDate,
      processDate: material.materialEnObra || material.dueDate,
      daysRemaining
    };
  };

  // ==================== FUNCIÓN PARA FILTRAR SUBCONTRATOS (OPTIMIZADA) ====================
  const subcontratosFiltrados = useMemo(() => {
    let resultado = [...tasks];
    
    // Filtro por texto (búsqueda en nombre de subcontrato) - usa debounce
    if (debouncedTextoBusqueda.trim() !== '') {
      const textoBusqueda = debouncedTextoBusqueda.toLowerCase();
      resultado = resultado.filter(task =>
        task.text.toLowerCase().includes(textoBusqueda)
      );
    }
    
    // Filtro por especialidad
    if (filtrosBusqueda.especialidad !== 'todas') {
      resultado = resultado.filter(task =>
        task.specialty === filtrosBusqueda.especialidad
      );
    }
    
    // Filtro por responsable
    if (filtrosBusqueda.responsable !== 'todos') {
      if (filtrosBusqueda.responsable === 'sin-responsable') {
        // Filtrar subcontratos sin responsable
        resultado = resultado.filter(task => !task.responsable || !task.responsable._id);
      } else {
        // Filtrar por responsable específico
        resultado = resultado.filter(task =>
          task.responsable && task.responsable._id === filtrosBusqueda.responsable
        );
      }
    }
    
    // Filtro por estado (completado o pendiente)
    if (filtrosBusqueda.estado === 'completado') {
      resultado = completedTasks;
    } else if (filtrosBusqueda.estado === 'pendiente') {
      // Ya está filtrando tasks (no completadas)
    }
    
    // Filtro por críticos (próximos 7 días)
    if (filtrosBusqueda.criticos) {
      const hoy = new Date();
      const enSieteDias = new Date(hoy);
      enSieteDias.setDate(hoy.getDate() + 7);
      
      resultado = resultado.filter(task => {
        const proximaFecha = getNextIncompleteProcess(task)?.fecha;
        if (!proximaFecha) return false;
        const fecha = new Date(proximaFecha);
        return fecha >= hoy && fecha <= enSieteDias;
      });
    }

    // Filtro por pendientes (importados sin partida/sección resuelta)
    if (filtrosBusqueda.pendientes) {
      resultado = resultado.filter(task => task.pendiente);
    }

    // Filtro por proceso
    if (filtrosBusqueda.proceso !== 'todos') {
      resultado = resultado.filter(task => {
        const procesoSeleccionado = filtrosBusqueda.proceso;
        const fileKey = `${task.id}-${procesoSeleccionado}`;
        const procesoCompletado = completedProcesses[fileKey];
        // Mostrar solo subcontratos donde este proceso NO está completado (o no aplica)
        return !procesoCompletado || !procesoCompletado.timestamp;
      });
    }
    
    return resultado;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tasks, debouncedTextoBusqueda, filtrosBusqueda.especialidad, filtrosBusqueda.responsable, filtrosBusqueda.estado, filtrosBusqueda.criticos, filtrosBusqueda.pendientes, filtrosBusqueda.proceso, completedTasks, completedProcesses, teamMembers]);
  
  // ==================== FUNCIÓN PARA FILTRAR MATERIALES (OPTIMIZADA) ====================
  const materialesFiltrados = useMemo(() => {
    let resultado = [...materiales];
    
    // Filtro por texto (búsqueda en nombre de material) - usa debounce
    if (debouncedTextoMateriales.trim() !== '') {
      const textoBusqueda = debouncedTextoMateriales.toLowerCase();
      resultado = resultado.filter(material =>
        material.text.toLowerCase().includes(textoBusqueda)
      );
    }
    
    // Filtro por especialidad
    if (filtrosMateriales.especialidad !== 'todas') {
      resultado = resultado.filter(material =>
        material.specialty === filtrosMateriales.especialidad
      );
    }
    
    // Filtro por responsable
    if (filtrosMateriales.responsable !== 'todos') {
      if (filtrosMateriales.responsable === 'sin-responsable') {
        // Filtrar materiales sin responsable
        resultado = resultado.filter(material => !material.responsable || !material.responsable._id);
      } else {
        // Filtrar por responsable específico
        resultado = resultado.filter(material =>
          material.responsable && material.responsable._id === filtrosMateriales.responsable
        );
      }
    }
    
    // Filtro por estado
    if (filtrosMateriales.estado === 'completado') {
      resultado = completedMateriales;
    } else if (filtrosMateriales.estado === 'pendiente') {
      // Ya está filtrando materiales (no completados)
    }
    
    // Filtro por críticos (próximos 7 días)
    if (filtrosMateriales.criticos) {
      const hoy = new Date();
      const enSieteDias = new Date(hoy);
      enSieteDias.setDate(hoy.getDate() + 7);
      
      resultado = resultado.filter(material => {
        const proximaFecha = getNextIncompleteMaterialProcess(material)?.fecha;
        if (!proximaFecha) return false;
        const fecha = new Date(proximaFecha);
        return fecha >= hoy && fecha <= enSieteDias;
      });
    }

    // Filtro por pendientes (importados sin partida/sección resuelta)
    if (filtrosMateriales.pendientes) {
      resultado = resultado.filter(material => material.pendiente);
    }
    
    // Filtro por proceso
    if (filtrosMateriales.proceso !== 'todos') {
      resultado = resultado.filter(material => {
        const procesoSeleccionado = filtrosMateriales.proceso;
        const fileKey = `${material.id}-${procesoSeleccionado}`;
        const procesoCompletado = completedProcessesMateriales[fileKey];
        // Mostrar solo materiales donde este proceso NO está completado (o no aplica)
        return !procesoCompletado || !procesoCompletado.timestamp;
      });
    }
    
    return resultado;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materiales, debouncedTextoMateriales, filtrosMateriales.especialidad, filtrosMateriales.responsable, filtrosMateriales.estado, filtrosMateriales.criticos, filtrosMateriales.pendientes, filtrosMateriales.proceso, completedMateriales, completedProcessesMateriales, teamMembers]);

  const renderTableRows = () => {
    // Usar subcontratos filtradas con useMemo (ya optimizado)
    // const subcontratosFiltrados ya está definido arriba con useMemo
    
    // Mantener orden estático de las subcontratos (sin ordenar por fecha)
    const sortedTasks = [...subcontratosFiltrados];
    
    // Agrupa las subcontratos por sección
    const grouped = {};
    sortedTasks.forEach((task) => {
      if (!grouped[task.specialty]) {
        grouped[task.specialty] = [];
      }
      grouped[task.specialty].push(task);
    });
    
    // Mantener orden estático de las secciones (sin ordenar por fecha)
    const orderedSections = [...sections];

    // Agregar secciones que existen en las subcontratos pero no en `sections`
    // (p.ej. la Sección aún no se persistió en el backend por algún error transitorio)
    const specialtiesInUse = new Set(Object.keys(grouped));
    const existingSectionNames = new Set(sections.map(s => s.name));

    specialtiesInUse.forEach(specialty => {
      if (!existingSectionNames.has(specialty)) {
        orderedSections.push({ id: `temp-${specialty}`, name: specialty });
      }
    });

    const rows = [];

    orderedSections.forEach((section) => {
      if (grouped[section.name]) {
        rows.push(
          <tr key={`section-${section.id}`} className="section-row">
            <td colSpan="11" className="section-header">
              {editSectionId === section.id ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px', paddingLeft: '20px' }}>
                  <input
                    type="text"
                    value={editSectionName}
                    onChange={e => setEditSectionName(e.target.value)}
                    className="section-edit-input"
                    disabled={isSavingSection}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && !isSavingSection) {
                        saveEditSection(section.id);
                      } else if (e.key === 'Escape') {
                        cancelEditSection();
                      }
                    }}
                  />
                  <button 
                    className="add-button section-button-save" 
                    onClick={() => saveEditSection(section.id)}
                    disabled={isSavingSection}
                  >
                    {isSavingSection ? 'Guardando...' : 'Guardar'}
                  </button>
                  <button 
                    className="delete-button section-button-cancel" 
                    onClick={cancelEditSection}
                    disabled={isSavingSection}
                  >
                    Cancelar
                  </button>
                  {sectionSaveError && (
                    <span style={{ 
                      marginLeft: '10px', 
                      color: '#dc2626', 
                      fontSize: '0.9rem',
                      fontWeight: 'normal'
                    }}>
                      {sectionSaveError}
                    </span>
                  )}
                </div>
              ) : (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px', paddingLeft: '20px' }}>
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '24px',
                      height: '24px',
                      cursor: 'pointer',
                      opacity: 0.7,
                      transition: 'opacity 0.2s, transform 0.2s',
                      borderRadius: '4px',
                      padding: '3px'
                    }}
                    onClick={() => startEditSection(section)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.opacity = '1';
                      e.currentTarget.style.transform = 'scale(1.1)';
                      e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.opacity = '0.7';
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    title="Editar nombre de sección"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#374151" width="18" height="18">
                      <path d="M15.85 6.15a.5.5 0 0 0 0-.7l-1.3-1.3a.5.5 0 0 0-.7 0l-8.1 8.1a.5.5 0 0 0-.13.24l-.7 2.8a.5.5 0 0 0 .61.61l2.8-.7a.5.5 0 0 0 .24-.13l8.1-8.1z"/>
                    </svg>
                  </span>
                  <span>{section.name}</span>
                </span>
              )}
            </td>
          </tr>
        );
        grouped[section.name].forEach((task) => {
          rows.push(
            <tr key={task.id} className={subcontratosSeleccionados.has(task.id) ? 'fila-seleccionada' : ''}>
              {/* Checkbox de selección */}
              <td className="checkbox-seleccion">
                <input
                  type="checkbox"
                  className="checkbox-seleccion-input"
                  checked={subcontratosSeleccionados.has(task.id)}
                  onChange={() => toggleTaskSelection(task.id)}
                />
              </td>
              {/* Responsable */}
              <td style={{ textAlign: 'center', padding: '8px' }}>
                {renderResponsableAvatar(task, true)}
              </td>
              
              {/* Nombre de subcontrato */}
              <td className="task-name">
                {task.text}
              </td>
              {/* Renderizar celdas de proceso según filtro activo */}
              {filtrosBusqueda.proceso === 'todos' ? (
                <>
                  {renderProcessCell(task, 'inicio')}
                  {renderProcessCell(task, 'envios')}
                  {renderProcessCell(task, 'comparativo')}
                  {renderProcessCell(task, 'negociacion')}
                  {renderProcessCell(task, 'precalificacion')}
                  {renderProcessCell(task, 'contratoFirmado')}
                </>
              ) : (
                renderProcessCell(task, filtrosBusqueda.proceso)
              )}
              {/* Inicio de Partida */}
              <td className="due-date">
                {task.pendiente ? (
                  <button
                    type="button"
                    onClick={() => resolverTaskPendiente(task)}
                    style={{ padding: '3px 10px', borderRadius: '999px', border: '1.5px solid #f59e0b', background: '#fffbeb', color: '#b45309', fontSize: '0.72rem', fontWeight: 700, cursor: 'pointer' }}
                    title="Elegir partida y/o sección"
                  >Pendiente</button>
                ) : (
                  <>
                    <strong>{formatDate(task.dueDate)}</strong>
                    {normalizarPartidas(task.partidaPrograma).length > 0 && (
                      <div style={{ fontSize: '0.68rem', color: '#6b7280', marginTop: 2, lineHeight: 1.2, fontWeight: 400 }}>
                        {normalizarPartidas(task.partidaPrograma).map(p => p.nombre).join(', ')}
                      </div>
                    )}
                  </>
                )}
              </td>
              <td>
                <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                  <button className="btn-editar-tabla" onClick={() => startEditTask(task)} title="Editar">✏</button>
                  <button
                    className="complete-button"
                    onClick={() => completeTask(task)}
                    disabled={isCompletingTask}
                  >
                    {isCompletingTask ? (
                      <span className="spinner"></span>
                    ) : (
                      'Completado'
                    )}
                  </button>
                  <button className="delete-button" onClick={() => removeTask(task.id)}>Eliminar</button>
                </div>
              </td>
            </tr>
          );
        });
        delete grouped[section.name];
      }
    });

    // Subcontratos sin sección asignada
    Object.values(grouped).forEach((taskList) => {
      taskList.forEach((task) => {
        // --- Editable para subcontratos sin sección ---
        rows.push(
          <tr key={task.id}>
            <td className="task-name">
              {task.text}
            </td>
            {/* Renderizar celdas de proceso según filtro activo */}
            {filtrosBusqueda.proceso === 'todos' ? (
              <>
                {renderProcessCell(task, 'inicio')}
                {renderProcessCell(task, 'envios')}
                {renderProcessCell(task, 'comparativo')}
                {renderProcessCell(task, 'negociacion')}
                {renderProcessCell(task, 'precalificacion')}
                {renderProcessCell(task, 'contratoFirmado')}
              </>
            ) : (
              renderProcessCell(task, filtrosBusqueda.proceso)
            )}
            <td className="due-date">
              {task.pendiente ? (
                <button
                  type="button"
                  onClick={() => resolverTaskPendiente(task)}
                  style={{ padding: '3px 10px', borderRadius: '999px', border: '1.5px solid #f59e0b', background: '#fffbeb', color: '#b45309', fontSize: '0.72rem', fontWeight: 700, cursor: 'pointer' }}
                  title="Elegir partida y/o sección"
                >Pendiente</button>
              ) : (
                <>
                  <strong>{formatDate(task.dueDate)}</strong>
                  {normalizarPartidas(task.partidaPrograma).length > 0 && (
                    <div style={{ fontSize: '0.68rem', color: '#6b7280', marginTop: 2, lineHeight: 1.2, fontWeight: 400 }}>
                      {normalizarPartidas(task.partidaPrograma).map(p => p.nombre).join(', ')}
                    </div>
                  )}
                </>
              )}
            </td>
            <td>
              <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                <button className="btn-editar-tabla" onClick={() => startEditTask(task)} title="Editar">✏</button>
                <button
                  className="complete-button"
                  onClick={() => completeTask(task)}
                  disabled={isCompletingTask}
                >
                  {isCompletingTask ? (
                    <span className="spinner"></span>
                  ) : (
                    'Completado'
                  )}
                </button>
                <button className="delete-button" onClick={() => removeTask(task.id)}>Eliminar</button>
              </div>
            </td>
          </tr>
        );
      });
    });

    return rows.length > 0 ? rows : <tr><td colSpan="10">No hay subcontratos añadidos</td></tr>;
  };

  const removeTask = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar este subcontrato?')) {
      return;
    }
    
    // Verificar si la subcontrato está completada
    const isCompleted = completedTasks.some(t => t.id === id);
    
    try {
      if (isCompleted) {
        // Eliminar de subcontratos completadas
        try {
          await subcontratosService.eliminarSubcontratoCompletado(id);
        } catch (error) {
          // Si es 404, la subcontrato ya no existe en el backend - continuar con limpieza local
          if (error.response?.status !== 404) {
            throw error; // Re-lanzar si es otro tipo de error
          }
        }
        setCompletedTasks((prev) => prev.filter((t) => t.id !== id));
      } else {
        // Eliminar de subcontratos normales
        try {
          await subcontratosService.eliminarSubcontrato(id);
        } catch (error) {
          // Si es 404, la subcontrato ya no existe en el backend - continuar con limpieza local
          if (error.response?.status !== 404) {
            throw error; // Re-lanzar si es otro tipo de error
          }
        }
        setTasks((prev) => prev.filter((t) => t.id !== id));
      }
    } catch (error) {
      console.error('❌ Error al eliminar subcontrato:', error);
      alert('Error al eliminar el subcontrato. Verifica la conexión con el backend.');
    }
  };

  // ==================== FUNCIONES DE SELECCIÓN MÚLTIPLE - SUBCONTRATOS ====================
  
  // Toggle selección individual de subcontrato
  const toggleTaskSelection = (taskId) => {
    setSubcontratosSeleccionados(prev => {
      const newSet = new Set(prev);
      if (newSet.has(taskId)) {
        newSet.delete(taskId);
      } else {
        newSet.add(taskId);
      }
      return newSet;
    });
  };

  // Seleccionar todas las subcontratos visibles (filtradas)
  const selectAllTasks = () => {
    const allVisibleIds = new Set(subcontratosFiltrados.map(t => t.id));
    setSubcontratosSeleccionados(allVisibleIds);
  };

  // Deseleccionar todas las subcontratos
  const clearAllTaskSelection = () => {
    setSubcontratosSeleccionados(new Set());
  };

  // Verificar si todas las subcontratos visibles están seleccionadas
  const allTasksSelected = subcontratosFiltrados.length > 0 && 
    subcontratosFiltrados.every(t => subcontratosSeleccionados.has(t.id));

  // Eliminar múltiples subcontratos seleccionadas
  const removeSelectedTasks = async () => {
    const cantidad = subcontratosSeleccionados.size;
    if (cantidad === 0) return;

    if (!window.confirm(`¿Estás seguro de eliminar ${cantidad} subcontrato${cantidad > 1 ? 's' : ''} seleccionado${cantidad > 1 ? 's' : ''}?\n\nEsta acción no se puede deshacer.`)) {
      return;
    }

    setEliminandoSeleccionados(true);
    
    try {
      const idsArray = Array.from(subcontratosSeleccionados);
      let eliminados = 0;
      let errores = 0;

      for (const id of idsArray) {
        try {
          // Verificar si la subcontrato está completada
          const isCompleted = completedTasks.some(t => t.id === id);
          
          if (isCompleted) {
            try {
              await subcontratosService.eliminarSubcontratoCompletado(id);
            } catch (error) {
              if (error.response?.status !== 404) throw error;
            }
            setCompletedTasks((prev) => prev.filter((t) => t.id !== id));
          } else {
            try {
              await subcontratosService.eliminarSubcontrato(id);
            } catch (error) {
              if (error.response?.status !== 404) throw error;
            }
            setTasks((prev) => prev.filter((t) => t.id !== id));
          }
          eliminados++;
        } catch (error) {
          console.error(`Error al eliminar subcontrato ${id}:`, error);
          errores++;
        }
      }

      // Limpiar selección
      setSubcontratosSeleccionados(new Set());

      if (errores > 0) {
        alert(`Se eliminaron ${eliminados} subcontratos.\n${errores} no pudieron eliminarse.`);
      }
    } catch (error) {
      console.error('Error en eliminación masiva:', error);
      alert('Error durante la eliminación. Algunos elementos podrían no haberse eliminado.');
    } finally {
      setEliminandoSeleccionados(false);
    }
  };

  const completeTask = async (task) => {
    // Verificar que todos los procesos estén completados
    const processes = ['envios', 'comparativo', 'negociacion', 'precalificacion', 'contratoFirmado'];
    const incompleteProcesses = [];
    
    for (let process of processes) {
      const fileKey = `${task.id}-${process}`;
      if (!completedProcesses[fileKey]) {
        incompleteProcesses.push(process);
      }
    }
    
    if (incompleteProcesses.length > 0) {
      const processNames = {
        'envios': 'Envíos',
        'comparativo': 'Comparativo',
        'negociacion': 'Negociación',
        'precalificacion': 'Pre-calificación',
        'contratoFirmado': 'Contrato Firmado'
      };
      const missingNames = incompleteProcesses.map(p => processNames[p]).join(', ');
      alert(`❌ No se puede completar el subcontrato.\n\nDebe completar todos los procesos primero.\n\nProcesos faltantes: ${missingNames}`);
      return;
    }
    
    setIsCompletingTask(true);
    try {
      // Marcar como completada en el backend - devuelve el nuevo documento con su ID
      const subcontratoCompletadoBackend = await subcontratosService.completarSubcontrato(task.id);
      
      // Usar el nuevo ID que devolvió el backend
      const completedTask = {
        ...task,
        id: subcontratoCompletadoBackend.id, // Usar el nuevo ID de la colección subcontratoscompletados
        completedDate: new Date().toISOString(),
      };
      
      setCompletedTasks((prev) => [completedTask, ...prev]);
      setTasks((prev) => prev.filter((t) => t.id !== task.id));
      
    } catch (error) {
      // Si es error 404, la subcontrato ya no existe en el backend
      if (error.response && error.response.status === 404) {
        setTasks((prev) => prev.filter((t) => t.id !== task.id));
      } else {
        console.error('❌ Error al completar subcontrato:', error);
        alert('Error al completar el subcontrato. Verifica la conexión con el backend.');
      }
    } finally {
      setIsCompletingTask(false);
    }
  };

  const deleteCompletedTask = async (id) => {
    try {
      await subcontratosService.eliminarSubcontratoCompletado(id);
      // Solo mostrar éxito si realmente se eliminó del backend
      setCompletedTasks((prev) => prev.filter((t) => t.id !== id));
    } catch (error) {
      // Si es error 404, la subcontrato ya no existe en el backend
      if (error.response && error.response.status === 404) {
        // Eliminar del estado local de todas formas, sin mostrar advertencia
        setCompletedTasks((prev) => prev.filter((t) => t.id !== id));
      } else {
        console.error('❌ Error al eliminar subcontrato completada:', error);
        alert('Error al eliminar el subcontrato completado.');
      }
    }
  };

  // ==================== RESTAURAR SUBCONTRATO COMPLETADO A ACTIVOS ====================
  const restoreCompletedTask = async (id) => {
    if (!window.confirm('¿Deseas devolver este subcontrato a la matriz activa?\n\nSe restaurará con todos sus procesos completados tal como estaba.')) {
      return;
    }
    try {
      const respuesta = await subcontratosService.restaurarSubcontrato(id);
      const subcontratoRestaurado = respuesta.subcontrato;
      
      // Agregar la subcontrato restaurada al estado de subcontratos activas
      const subcontratoFormateado = {
        id: subcontratoRestaurado._id,
        text: subcontratoRestaurado.texto,
        madeBy: subcontratoRestaurado.hechoPor,
        specialty: subcontratoRestaurado.especialidad,
        dueDate: subcontratoRestaurado.fechaEntrega,
        section: subcontratoRestaurado.seccion,
        inicio: subcontratoRestaurado.inicio,
        envios: subcontratoRestaurado.envios,
        comparativo: subcontratoRestaurado.comparativo,
        negociacion: subcontratoRestaurado.negociacion,
        precalificacion: subcontratoRestaurado.precalificacion,
        contratoFirmado: subcontratoRestaurado.contratoFirmado
      };
      
      setTasks((prev) => [subcontratoFormateado, ...prev]);
      
      // Restaurar los procesos completados en el estado local
      if (subcontratoRestaurado.procesosCompletados) {
        const procesos = subcontratoRestaurado.procesosCompletados instanceof Map 
          ? Object.fromEntries(subcontratoRestaurado.procesosCompletados)
          : subcontratoRestaurado.procesosCompletados;
        
        const nuevosProcesos = {};
        Object.entries(procesos).forEach(([proceso, datos]) => {
          const fileKey = `${subcontratoRestaurado._id}-${proceso}`;
          nuevosProcesos[fileKey] = {
            timestamp: datos.marcaTiempo || new Date().toISOString(),
            filesCount: datos.cantidadArchivos || 0,
            commentsCount: datos.cantidadComentarios || 0,
            noAplica: datos.noAplica || false,
            precioPresupuestado: datos.precioPresupuestado,
            precioCierre: datos.precioCierre
          };
        });
        
        setCompletedProcesses((prev) => ({ ...prev, ...nuevosProcesos }));
      }
      
      // Eliminar de completadas
      setCompletedTasks((prev) => prev.filter((t) => t.id !== id));
      
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCompletedTasks((prev) => prev.filter((t) => t.id !== id));
      } else {
        console.error('❌ Error al restaurar subcontrato:', error);
        alert('Error al restaurar el subcontrato. Intenta de nuevo.');
      }
    }
  };

  // ==================== RESTAURAR MATERIAL COMPLETADO A ACTIVOS ====================
  const restoreCompletedMaterial = async (id) => {
    if (!window.confirm('¿Deseas devolver este material a la matriz activa?\n\nSe restaurará con todos sus procesos completados tal como estaba.')) {
      return;
    }
    try {
      const respuesta = await materialesService.restaurarMaterial(id);
      const materialRestaurado = respuesta.material;
      
      // Agregar el material restaurado al estado de materiales activos
      const materialFormateado = {
        id: materialRestaurado._id,
        text: materialRestaurado.text,
        specialty: materialRestaurado.specialty || '',
        dueDate: materialRestaurado.dueDate,
        responsable: materialRestaurado.responsable,
        inicio: materialRestaurado.inicio,
        cubicacion: materialRestaurado.cubicacion,
        revCubicacion: materialRestaurado.revCubicacion,
        solped: materialRestaurado.solped,
        ocAprobada: materialRestaurado.ocAprobada,
        materialEnObra: materialRestaurado.materialEnObra || materialRestaurado.dueDate,
        createdAt: materialRestaurado.createdAt
      };
      
      setMateriales((prev) => [materialFormateado, ...prev]);
      
      // Restaurar los procesos completados de materiales en el estado local
      if (materialRestaurado.procesosCompletados) {
        const procesos = materialRestaurado.procesosCompletados instanceof Map 
          ? Object.fromEntries(materialRestaurado.procesosCompletados)
          : materialRestaurado.procesosCompletados;
        
        const nuevosProcesos = {};
        Object.entries(procesos).forEach(([proceso, datos]) => {
          const fileKey = `${materialRestaurado._id}-${proceso}`;
          nuevosProcesos[fileKey] = {
            timestamp: datos.marcaTiempo || new Date().toISOString(),
            filesCount: datos.cantidadArchivos || 0,
            commentsCount: datos.cantidadComentarios || 0,
            noAplica: datos.noAplica || false,
            precioPresupuestado: datos.precioPresupuestado,
            precioCierre: datos.precioCierre
          };
        });
        
        setCompletedProcessesMateriales((prev) => ({ ...prev, ...nuevosProcesos }));
      }
      
      // Eliminar de completados
      setCompletedMateriales((prev) => prev.filter((m) => m.id !== id));
      
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCompletedMateriales((prev) => prev.filter((m) => m.id !== id));
      } else {
        console.error('❌ Error al restaurar material:', error);
        alert('Error al restaurar el material. Intenta de nuevo.');
      }
    }
  };

  // ==================== HANDLERS RECEPCIÓN ====================

  // Helper para formatear un certificado (partida) del backend al formato del frontend
  const formatearCertificado = (c) => ({
    id: c._id,
    nombrePartida: c.nombrePartida || '',
    especialidad: c.especialidad || '',
    terminoPartida: c.terminoPartida ? c.terminoPartida.split('T')[0] : '',
    documentos: (c.documentos || []).map(doc => ({
      id: doc._id,
      nombre: doc.nombre || '',
      fechaProgramada: doc.fechaProgramada ? doc.fechaProgramada.split('T')[0] : '',
      fechaEsperada: doc.fechaEsperada ? doc.fechaEsperada.split('T')[0] : '',
      archivos: doc.archivos || [],
      observaciones: doc.observaciones || '',
      completado: doc.completado || false,
      fechaCompletado: doc.fechaCompletado ? doc.fechaCompletado.split('T')[0] : ''
    })),
    responsable: c.responsable ? c.responsable._id || c.responsable : '',
    responsables: (c.responsables || []).map(r => r._id || r),
    responsablesExternos: c.responsablesExternos || []
  });

  const formatearCertificadoCompletado = (c) => ({
    id: c._id,
    nombrePartida: c.nombrePartida || '',
    especialidad: c.especialidad || '',
    terminoPartida: c.terminoPartida ? c.terminoPartida.split('T')[0] : '',
    documentos: (c.documentos || []).map(doc => ({
      id: doc._id,
      nombre: doc.nombre || '',
      fechaProgramada: doc.fechaProgramada ? doc.fechaProgramada.split('T')[0] : '',
      fechaEsperada: doc.fechaEsperada ? doc.fechaEsperada.split('T')[0] : '',
      archivos: doc.archivos || [],
      observaciones: doc.observaciones || '',
      completado: doc.completado || false,
      fechaCompletado: doc.fechaCompletado ? doc.fechaCompletado.split('T')[0] : ''
    })),
    fechaReal: c.fechaReal ? c.fechaReal.split('T')[0] : '',
    responsable: c.responsable
      ? (typeof c.responsable === 'object' ? c.responsable.nombre : c.responsable)
      : '',
    responsables: (c.responsables || []).map(r => typeof r === 'object' ? r.nombre : r),
    responsablesExternos: c.responsablesExternos || []
  });

  const handleActualizarFechasRecepcion = async (nuevasFechas) => {
    try {
      const resultado = await certificadosService.actualizarFechasRecepcion(nuevasFechas);
      setFechasRecepcion({
        fechaRecepcionPrograma: resultado.fechaRecepcionPrograma ? resultado.fechaRecepcionPrograma.split('T')[0] : '',
        fechaRecepcionEsperada: resultado.fechaRecepcionEsperada ? resultado.fechaRecepcionEsperada.split('T')[0] : '',
        mesesRecepcion: resultado.mesesRecepcion ?? 0,
      });
      // Recargar certificados para reflejar las fechas recalculadas
      const certs = await certificadosService.obtenerCertificados();
      setCertificados(certs.map(formatearCertificado));
    } catch (error) {
      console.error('❌ Error al actualizar fechas de recepción:', error);
      throw error;
    }
  };

  const handleCrearCertificado = async (datos) => {
    try {
      const nuevo = await certificadosService.crearCertificado(datos);
      const formateado = formatearCertificado(nuevo);
      setCertificados(prev => [...prev, formateado]);
      return formateado;
    } catch (error) {
      console.error('❌ Error al crear certificado:', error);
      throw error;
    }
  };

  const handleActualizarCertificado = async (idCertificado, datosActualizados) => {
    try {
      const actualizado = await certificadosService.actualizarCertificado(idCertificado, datosActualizados);
      const formateado = formatearCertificado(actualizado);
      setCertificados(prev => prev.map(c => c.id === idCertificado ? formateado : c));
      return formateado;
    } catch (error) {
      console.error('❌ Error al actualizar certificado:', error);
      throw error;
    }
  };

  const handleEliminarCertificado = async (idCertificado) => {
    try {
      await certificadosService.eliminarCertificado(idCertificado);
      setCertificados(prev => prev.filter(c => c.id !== idCertificado));
    } catch (error) {
      console.error('❌ Error al eliminar certificado:', error);
      throw error;
    }
  };

  const handleToggleDocumentoCompletado = async (idCertificado, idDocumento) => {
    try {
      const certActualizado = await certificadosService.toggleDocumentoCompletado(idCertificado, idDocumento);
      const formateado = formatearCertificado(certActualizado);
      setCertificados(prev => prev.map(c => c.id === formateado.id ? formateado : c));
    } catch (error) {
      console.error('❌ Error al toggle documento completado:', error);
      throw error;
    }
  };

  const handleCompletarCertificado = async (idCertificado, fechaReal) => {
    try {
      const completado = await certificadosService.completarCertificado(idCertificado, fechaReal);
      setCertificados(prev => prev.filter(c => c.id !== idCertificado));
      const formateado = formatearCertificadoCompletado(completado);
      setCertificadosCompletados(prev => [...prev, formateado]);
    } catch (error) {
      console.error('❌ Error al completar certificado:', error);
      throw error;
    }
  };

  // Handlers para documentos dentro de una partida
  const handleAgregarDocumento = async (idCertificado, datos) => {
    try {
      const actualizado = await certificadosService.agregarDocumento(idCertificado, datos);
      const formateado = formatearCertificado(actualizado);
      setCertificados(prev => prev.map(c => c.id === idCertificado ? formateado : c));
      return formateado;
    } catch (error) {
      console.error('❌ Error al agregar documento:', error);
      throw error;
    }
  };

  const handleActualizarDocumento = async (idCertificado, idDocumento, datos) => {
    try {
      const actualizado = await certificadosService.actualizarDocumento(idCertificado, idDocumento, datos);
      const formateado = formatearCertificado(actualizado);
      setCertificados(prev => prev.map(c => c.id === idCertificado ? formateado : c));
      return formateado;
    } catch (error) {
      console.error('❌ Error al actualizar documento:', error);
      throw error;
    }
  };

  const handleEliminarDocumento = async (idCertificado, idDocumento) => {
    try {
      const actualizado = await certificadosService.eliminarDocumento(idCertificado, idDocumento);
      const formateado = formatearCertificado(actualizado);
      setCertificados(prev => prev.map(c => c.id === idCertificado ? formateado : c));
      return formateado;
    } catch (error) {
      console.error('❌ Error al eliminar documento:', error);
      throw error;
    }
  };

  const handleCrearSeccionRecepcion = async (datos) => {
    try {
      const nuevaSeccion = await certificadosService.crearSeccion(datos);
      const formateada = { id: nuevaSeccion._id, name: nuevaSeccion.nombre };
      setSeccionesRecepcion(prev => [...prev, formateada]);
      return formateada;
    } catch (error) {
      console.error('❌ Error al crear sección RECEPCIÓN:', error);
      throw error;
    }
  };

  const handleEliminarSeccionRecepcion = async (idSeccion) => {
    try {
      await certificadosService.eliminarSeccion(idSeccion);
      setSeccionesRecepcion(prev => prev.filter(s => s.id !== idSeccion));
    } catch (error) {
      console.error('❌ Error al eliminar sección RECEPCIÓN:', error);
      throw error;
    }
  };
  // ==================== HANDLERS RECEPCIÓN - RECEPCIÓN DE OBRA ====================

  const handleActualizarMesesRecepcionObra = async (mesesContractual, mesesProgramado) => {
    try {
      const resultado = await certificadosService.actualizarMesesRecepcionObra(
        mesesContractual, mesesProgramado
      );
      setMesesRecepcionObra({
        mesesContractual: resultado.mesesContractual ?? 0,
        mesesProgramado:  resultado.mesesProgramado  ?? 0,
      });
      const certs = await certificadosService.obtenerCertificadosObra();
      setCertificadosObra(certs.map(formatearCertificado));
    } catch (error) {
      console.error('❌ Error al actualizar meses de recepción de obra:', error);
      throw error;
    }
  };

  const handleCrearCertificadoObra = async (datos) => {
    try {
      const nuevo = await certificadosService.crearCertificadoObra(datos);
      const formateado = formatearCertificado(nuevo);
      setCertificadosObra(prev => [...prev, formateado]);
      return formateado;
    } catch (error) {
      console.error('❌ Error al crear certificado de obra:', error);
      throw error;
    }
  };

  const handleAgregarDocumentoObra = async (idCertificado, datos) => {
    try {
      const actualizado = await certificadosService.agregarDocumento(idCertificado, datos);
      const formateado = formatearCertificado(actualizado);
      setCertificadosObra(prev => prev.map(c => c.id === idCertificado ? formateado : c));
      return formateado;
    } catch (error) {
      console.error('❌ Error al agregar documento de obra:', error);
      throw error;
    }
  };

  const handleActualizarDocumentoObra = async (idCertificado, idDocumento, datos) => {
    try {
      const actualizado = await certificadosService.actualizarDocumento(idCertificado, idDocumento, datos);
      const formateado = formatearCertificado(actualizado);
      setCertificadosObra(prev => prev.map(c => c.id === idCertificado ? formateado : c));
      return formateado;
    } catch (error) {
      console.error('❌ Error al actualizar documento de obra:', error);
      throw error;
    }
  };

  const handleEliminarDocumentoObra = async (idCertificado, idDocumento) => {
    try {
      const actualizado = await certificadosService.eliminarDocumento(idCertificado, idDocumento);
      const formateado = formatearCertificado(actualizado);
      setCertificadosObra(prev => prev.map(c => c.id === idCertificado ? formateado : c));
      return formateado;
    } catch (error) {
      console.error('❌ Error al eliminar documento de obra:', error);
      throw error;
    }
  };

  const handleToggleDocumentoCompletadoObra = async (idCertificado, idDocumento) => {
    try {
      const certActualizado = await certificadosService.toggleDocumentoCompletado(idCertificado, idDocumento);
      const formateado = formatearCertificado(certActualizado);
      setCertificadosObra(prev => prev.map(c => c.id === formateado.id ? formateado : c));
    } catch (error) {
      console.error('❌ Error al toggle documento completado de obra:', error);
      throw error;
    }
  };

  // ==================== FIN HANDLERS RECEPCIÓN ====================

  const openStageModal = async (task, stage) => {
    setSelectedTask(task);
    setSelectedStage(stage);
    setShowModal(true);
    
    // Cargar datos de precios si el proceso está completado
    const fileKey = `${task.id}-${stage}`;
    const procesoCompletado = completedProcesses[fileKey];
    if (procesoCompletado && stage === 'contratoFirmado') {
      if (procesoCompletado.precioPresupuestado) {
        setPrecioPresupuestado(procesoCompletado.precioPresupuestado.toString());
      }
      if (procesoCompletado.precioCierre) {
        setPrecioCierre(procesoCompletado.precioCierre.toString());
      }
    }
    
    // Cargar documentos existentes desde MongoDB
    try {
      const response = await api.get(`/documentos/relacionado/subcontrato/${task.id}`);
      const docsDelProceso = response.data.documentos.filter(doc => doc.proceso === stage);
      
      if (docsDelProceso.length > 0) {
        // Convertir documentos de MongoDB a objetos File para mostrar en el modal
        const fileKey = `${task.id}-${stage}`;
        const archivosExistentes = docsDelProceso.map(doc => ({
          _id: doc._id,
          name: doc.nombre,
          size: doc.tamano,
          type: doc.mimeType,
          fromMongoDB: true // Marcador para identificar que viene de MongoDB
        }));
        
        setStageFiles(prev => ({
          ...prev,
          [fileKey]: archivosExistentes
        }));
        
        // Cargar comentarios si existen
        if (docsDelProceso[0]?.comentarios) {
          setStageComments(prev => ({
            ...prev,
            [fileKey]: [{
              id: Date.now(),
              text: docsDelProceso[0].comentarios,
              timestamp: new Date(docsDelProceso[0].createdAt).toLocaleString('es-ES')
            }]
          }));
        }
      }
    } catch (error) {
      console.error('❌ Error al cargar documentos:', error);
    }
  };

  const closeStageModal = () => {
    setShowModal(false);
    setSelectedTask(null);
    setSelectedStage(null);
    setProcessNoAplica(false); // Limpiar estado de "No aplica"
    setPrecioPresupuestado(''); // Limpiar precio presupuestado
    setPrecioCierre(''); // Limpiar precio de cierre
    // NO limpiamos stageFiles ni stageComments para que persistan
  };

  const handleFileUpload = (e) => {
    const files = e.target.files;
    if (files && selectedTask && selectedStage) {
      const fileKey = `${selectedTask.id}-${selectedStage}`;
      const fileList = Array.from(files);
      setStageFiles((prev) => ({
        ...prev,
        [fileKey]: [...(prev[fileKey] || []), ...fileList],
      }));
    }
  };

  const saveStageData = async () => {
    if (selectedTask && selectedStage && currentComment.trim()) {
      const fileKey = `${selectedTask.id}-${selectedStage}`;
      const newComment = {
        id: Date.now(),
        text: currentComment,
        timestamp: new Date().toLocaleString('es-ES'),
      };
      
      // Actualizar estado local
      const comentariosActualizados = [...(stageComments[fileKey] || []), newComment];
      setStageComments((prev) => ({
        ...prev,
        [fileKey]: comentariosActualizados,
      }));
      
      // Guardar comentario en el backend inmediatamente
      try {
        const comentariosTexto = comentariosActualizados.map(c => c.text).join('\n');
        await subcontratosService.marcarProcesoCompletado(selectedTask.id, selectedStage, {
          marcaTiempo: new Date().toLocaleString('es-ES'),
          cantidadArchivos: stageFiles[fileKey]?.length || 0,
          cantidadComentarios: comentariosActualizados.length,
          archivos: [], // No enviar archivos nuevos, solo actualizar comentarios
          comentarios: comentariosTexto,
          noAplica: false,
          soloComentario: true // Indicar que solo se está guardando comentario
        });
      } catch (error) {
        console.error('❌ Error al guardar comentario:', error);
        alert('Error al guardar el comentario. Por favor intenta de nuevo.');
      }
      
      setCurrentComment('');
    }
  };

  const markProcessComplete = async () => {
    if (selectedTask && selectedStage) {
      const fileKey = `${selectedTask.id}-${selectedStage}`;
      const hasFiles = stageFiles[fileKey] && stageFiles[fileKey].length > 0;
      const hasComments = stageComments[fileKey] && stageComments[fileKey].length > 0;

      // Permitir completar si tiene archivos, comentarios o está marcado como "No aplica"
      if (hasFiles || hasComments || processNoAplica) {
        setIsSavingProcess(true);
        const timestamp = new Date().toLocaleString('es-ES');
        const completionData = {
          timestamp: timestamp,
          filesCount: hasFiles ? stageFiles[fileKey].length : 0,
          commentsCount: hasComments ? stageComments[fileKey].length : 0,
          noAplica: processNoAplica,
          precioPresupuestado: precioPresupuestado ? parseFloat(precioPresupuestado) : undefined,
          precioCierre: precioCierre ? parseFloat(precioCierre) : undefined
        };
        
        try {
          // Convertir solo archivos NUEVOS a base64 (los que no vienen de MongoDB)
          const archivosBase64 = [];
          if (hasFiles) {
            const archivosNuevos = stageFiles[fileKey].filter(f => !f.fromMongoDB);
            
            for (const file of archivosNuevos) {
              const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                  // Extraer solo el base64 sin el prefijo data:application/pdf;base64,
                  const result = reader.result.split(',')[1];
                  resolve(result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
              });
              
              archivosBase64.push({
                nombre: file.name,
                base64: base64,
                mimeType: file.type,
                tamano: file.size
              });
            }
          }
          
          // Preparar comentarios
          const comentariosTexto = hasComments 
            ? stageComments[fileKey].map(c => c.text).join('\n')
            : (processNoAplica ? 'N/A - No aplica' : '');
          
          // Preparar datos de precios si es Contrato Firmado
          const datosPrecios = selectedStage === 'contratoFirmado' ? {
            precioPresupuestado: precioPresupuestado ? parseFloat(precioPresupuestado) : undefined,
            precioCierre: precioCierre ? parseFloat(precioCierre) : undefined
          } : {};
          
          // Enviar al backend si hay archivos nuevos, comentarios o es "No aplica"
          if (archivosBase64.length > 0 || comentariosTexto || processNoAplica) {
            await subcontratosService.marcarProcesoCompletado(selectedTask.id, selectedStage, {
              marcaTiempo: timestamp,
              cantidadArchivos: hasFiles ? stageFiles[fileKey].length : 0,
              cantidadComentarios: hasComments ? stageComments[fileKey].length : 0,
              archivos: archivosBase64,
              comentarios: comentariosTexto,
              noAplica: processNoAplica,
              ...datosPrecios
            });
            
            
            // Recargar documentos de subcontratos desde MongoDB
            try {
              const responseSub = await api.get('/documentos');
              const docsSub = Array.isArray(responseSub.data) ? responseSub.data : [];
              setDocumentosSubcontratos(docsSub);
            } catch (error) {
              console.error('Error al recargar documentos:', error);
            }
          }
          
          // Actualizar estado local
          setCompletedProcesses((prev) => ({
            ...prev,
            [fileKey]: completionData,
          }));
          
          closeStageModal();
        } catch (error) {
          console.error('❌ Error al guardar proceso completado:', error);
          alert('Error al guardar el proceso. Verifica la conexión con el backend.');
        } finally {
          setIsSavingProcess(false);
        }
      }
    }
  };

  const removeComment = (fileKey, commentId) => {
    setStageComments((prev) => ({
      ...prev,
      [fileKey]: prev[fileKey].filter((comment) => comment.id !== commentId),
    }));
  };

  const removeFile = async (fileKey, index) => {
    const archivo = stageFiles[fileKey]?.[index];
    
    // Si el archivo viene de MongoDB, eliminarlo de la base de datos
    if (archivo?.fromMongoDB && archivo._id) {
      try {
        await api.delete(`/documentos/${archivo._id}`);
      } catch (error) {
        console.error('❌ Error al eliminar archivo de MongoDB:', error);
        alert('Error al eliminar el archivo de la base de datos');
        return;
      }
    }
    
    // Eliminar del estado local
    setStageFiles((prev) => ({
      ...prev,
      [fileKey]: prev[fileKey].filter((_, i) => i !== index),
    }));
  };

  // ==================== ELIMINAR TODOS LOS DOCUMENTOS DE UN SUBCONTRATO ====================
  const eliminarDocumentosSubcontrato = async (subcontratoId, subcontratoNombre) => {
    if (!window.confirm(`¿Estás seguro de eliminar TODOS los documentos de "${subcontratoNombre}"?\n\nEsta acción no se puede deshacer.`)) {
      return;
    }

    try {
      // Obtener todos los documentos de esta subcontrato
      const docsAEliminar = documentosSubcontratos.filter(doc => doc.relacionadoId === subcontratoId);
      
      if (docsAEliminar.length === 0) {
        alert('No hay documentos para eliminar');
        return;
      }

      // Eliminar cada documento
      for (const doc of docsAEliminar) {
        await api.delete(`/documentos/${doc._id}`);
      }

      // Actualizar estado local
      setDocumentosSubcontratos(prev => prev.filter(doc => doc.relacionadoId !== subcontratoId));
      
      alert(`Se eliminaron ${docsAEliminar.length} documento(s) exitosamente`);
    } catch (error) {
      console.error('❌ Error al eliminar documentos:', error);
      alert('Error al eliminar los documentos');
    }
  };

  // ==================== ELIMINAR TODOS LOS DOCUMENTOS DE UN MATERIAL ====================
  const eliminarDocumentosMaterial = async (materialId, materialNombre) => {
    if (!window.confirm(`¿Estás seguro de eliminar TODOS los documentos de "${materialNombre}"?\n\nEsta acción no se puede deshacer.`)) {
      return;
    }

    try {
      // Obtener todos los documentos de este material
      const docsAEliminar = documentosMateriales.filter(doc => doc.materialId === materialId);
      
      if (docsAEliminar.length === 0) {
        alert('No hay documentos para eliminar');
        return;
      }

      // Eliminar cada documento
      for (const doc of docsAEliminar) {
        await documentosMaterialesService.eliminarDocumento(doc._id);
      }

      // Actualizar estado local
      setDocumentosMateriales(prev => prev.filter(doc => doc.materialId !== materialId));
      
      alert(`Se eliminaron ${docsAEliminar.length} documento(s) exitosamente`);
    } catch (error) {
      console.error('❌ Error al eliminar documentos:', error);
      alert('Error al eliminar los documentos');
    }
  };

  // ==================== RECARGAR DOCUMENTOS DE SUBCONTRATOS ====================
  const cargarDocumentos = async () => {
    try {
      const responseSub = await api.get('/documentos');
      const docsSub = Array.isArray(responseSub.data) ? responseSub.data : [];
      setDocumentosSubcontratos(docsSub);
    } catch (error) {
      console.error('❌ Error al recargar documentos:', error);
    }
  };

  // ==================== RECARGAR DOCUMENTOS DE MATERIALES ====================
  const cargarDocumentosMateriales = async () => {
    try {
      const proyectoId = localStorage.getItem('proyectoId');
      if (proyectoId) {
        const docsMat = await documentosMaterialesService.obtenerDocumentosProyecto(proyectoId);
        const docsMatArray = Array.isArray(docsMat) ? docsMat : [];
        setDocumentosMateriales(docsMatArray);
      }
    } catch (error) {
      console.error('❌ Error al recargar documentos de materiales:', error);
    }
  };

  // ==================== REVERTIR PROCESO DE SUBCONTRATO ====================
  const revertTaskProcess = async () => {
    if (!selectedTask || !selectedStage) return;

    const processNames = {
      'envios': 'Envíos',
      'comparativo': 'Comparativo',
      'negociacion': 'Negociación',
      'precalificacion': 'Pre-calificación',
      'contratoFirmado': 'Contrato Firmado'
    };

    const confirmed = window.confirm(
      `¿Estás seguro de descompletar el proceso "${processNames[selectedStage]}"?\n\n` +
      `Esto eliminará:\n` +
      `- El ticket de progreso completado\n` +
      `- Todos los documentos adjuntos\n` +
      `- Todos los comentarios\n\n` +
      `Esta acción no se puede deshacer.`
    );

    if (!confirmed) return;

    setIsRevertingProcess(true);
    try {
      // Llamar al backend para descompletar el proceso
      await subcontratosService.descompletarProceso(selectedTask.id, selectedStage);

      // Eliminar del estado local completedProcesses
      const fileKey = `${selectedTask.id}-${selectedStage}`;
      setCompletedProcesses(prev => {
        const updated = { ...prev };
        delete updated[fileKey];
        return updated;
      });

      // Limpiar archivos y comentarios del estado
      setStageFiles(prev => {
        const updated = { ...prev };
        delete updated[fileKey];
        return updated;
      });

      setStageComments(prev => {
        const updated = { ...prev };
        delete updated[fileKey];
        return updated;
      });

      // Recargar documentos para actualizar la vista
      await cargarDocumentos();

      alert(`Proceso "${processNames[selectedStage]}" descompletado exitosamente`);

      // Cerrar el modal
      closeStageModal();
    } catch (error) {
      console.error('❌ Error al descompletar proceso:', error);
      alert('Error al descompletar el proceso. Por favor, intenta de nuevo.');
    } finally {
      setIsRevertingProcess(false);
    }
  };

  // ==================== REVERTIR PROCESO DE MATERIAL ====================
  const revertMaterialProcess = async () => {
    if (!selectedMaterial || !selectedMaterialStage) return;

    const processNames = {
      'cubicacion': 'Cubicación',
      'revCubicacion': 'Rev. Cubicación',
      'solped': 'Solped',
      'ocAprobada': 'OC Aprobada',
      'materialEnObra': 'Material en Obra'
    };

    const confirmed = window.confirm(
      `¿Estás seguro de descompletar el proceso "${processNames[selectedMaterialStage]}"?\n\n` +
      `Esto eliminará:\n` +
      `- El ticket de progreso completado\n` +
      `- Todos los documentos adjuntos\n` +
      `- Todos los comentarios\n\n` +
      `Esta acción no se puede deshacer.`
    );

    if (!confirmed) return;

    setIsRevertingMaterialProcess(true);
    try {
      // Llamar al backend para descompletar el proceso
      await materialesService.descompletarProcesoMaterial(selectedMaterial.id, selectedMaterialStage);

      // Eliminar del estado local completedProcessesMateriales
      const fileKey = `${selectedMaterial.id}-${selectedMaterialStage}`;
      setCompletedProcessesMateriales(prev => {
        const updated = { ...prev };
        delete updated[fileKey];
        return updated;
      });

      // Limpiar archivos y comentarios del estado
      setMaterialStageFiles(prev => {
        const updated = { ...prev };
        delete updated[fileKey];
        return updated;
      });

      setMaterialStageComments(prev => {
        const updated = { ...prev };
        delete updated[fileKey];
        return updated;
      });

      // Recargar documentos para actualizar la vista
      await cargarDocumentosMateriales();

      alert(`Proceso "${processNames[selectedMaterialStage]}" descompletado exitosamente`);

      // Cerrar el modal
      closeMaterialStageModal();
    } catch (error) {
      console.error('❌ Error al descompletar proceso:', error);
      alert('Error al descompletar el proceso. Por favor, intenta de nuevo.');
    } finally {
      setIsRevertingMaterialProcess(false);
    }
  };

  // ==================== AGRUPAR DOCUMENTOS POR SECCIÓN ====================
  const agruparDocumentosPorSeccion = (documentos) => {
    return documentos.reduce((acc, doc) => {
      const especialidad = doc.especialidad || 'Sin especialidad';
      
      if (!acc[especialidad]) {
        acc[especialidad] = {
          nombre: especialidad,
          items: {}
        };
      }
      
      // Agrupar por relacionadoId o materialId
      const itemId = doc.relacionadoId || doc.materialId;
      const itemNombre = doc.relacionadoNombre || doc.materialNombre;
      
      if (!acc[especialidad].items[itemId]) {
        acc[especialidad].items[itemId] = {
          id: itemId,
          nombre: itemNombre,
          especialidad: especialidad,
          documentos: []
        };
      }
      
      acc[especialidad].items[itemId].documentos.push(doc);
      
      return acc;
    }, {});
  };

  // ==================== TOGGLE EXPANSIÓN DE SECCIÓN ====================
  const toggleSeccionSubcontrato = (especialidad) => {
    setExpandedSectionsSubcontratos(prev => ({
      ...prev,
      [especialidad]: !prev[especialidad]
    }));
  };

  const toggleSeccionMateriales = (especialidad) => {
    setExpandedSectionsMateriales(prev => ({
      ...prev,
      [especialidad]: !prev[especialidad]
    }));
  };

  // ==================== EXPANDIR/COLAPSAR TODAS LAS SECCIONES ====================
  const expandirTodasSubcontratos = () => {
    const secciones = Object.keys(agruparDocumentosPorSeccion(documentosSubcontratos));
    const nuevoEstado = {};
    secciones.forEach(sec => nuevoEstado[sec] = true);
    setExpandedSectionsSubcontratos(nuevoEstado);
  };

  const colapsarTodasSubcontratos = () => {
    setExpandedSectionsSubcontratos({});
  };

  const expandirTodasMateriales = () => {
    const secciones = Object.keys(agruparDocumentosPorSeccion(documentosMateriales));
    const nuevoEstado = {};
    secciones.forEach(sec => nuevoEstado[sec] = true);
    setExpandedSectionsMateriales(nuevoEstado);
  };

  const colapsarTodasMateriales = () => {
    setExpandedSectionsMateriales({});
  };

  const downloadFile = async (file) => {
    // Si es un archivo de MongoDB, descargarlo desde allí
    if (file.fromMongoDB && file._id) {
      try {
        const response = await api.get(`/documentos/${file._id}`);
        const doc = response.data.documento;
        
        // Convertir base64 a blob
        const byteCharacters = atob(doc.archivoBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: doc.mimeType });
        
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = doc.nombre;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('❌ Error al descargar archivo:', error);
        alert('Error al descargar el archivo');
      }
    } else {
      // Archivo local normal
      const url = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  const openFileViewer = async (file) => {
    // Si es un archivo de MongoDB, abrirlo desde allí
    if (file.fromMongoDB && file._id) {
      try {
        const response = await api.get(`/documentos/${file._id}`);
        const doc = response.data.documento;
        
        // Convertir base64 a blob
        const byteCharacters = atob(doc.archivoBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: doc.mimeType });
        
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (error) {
        console.error('❌ Error al abrir archivo:', error);
        alert('Error al abrir el archivo');
      }
    } else {
      // Archivo local normal
      const url = URL.createObjectURL(file);
      window.open(url, '_blank');
    }
  };

  const formatDate = (date) => {
    if (!date) return '';
    const meses = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    let fechaNormalizada;
    if (typeof date === 'string' && date.includes('-') && !date.includes('T')) {
      const [year, month, day] = date.split('-').map(num => parseInt(num));
      fechaNormalizada = new Date(year, month - 1, day);
    } else {
      fechaNormalizada = new Date(date);
    }
    const d = String(fechaNormalizada.getDate()).padStart(2, '0');
    const m = meses[fechaNormalizada.getMonth()];
    const y = fechaNormalizada.getFullYear();
    return `${d}/${m}/${y}`;
  };

  const getTopCriticalTasks = () => {
    const sortedTasks = [...tasks].map((task) => {
      const nextProcess = getNextIncompleteProcess(task);
      return {
        ...task,
        nextProcess: nextProcess.processName,
        nextProcessDate: nextProcess.processDate,
        daysUntilDue: nextProcess.daysRemaining,
      };
    }).sort((a, b) => a.daysUntilDue - b.daysUntilDue);
    
    return sortedTasks.slice(0, 15);
  };

  // Función para obtener materiales más críticos
  const getTopCriticalMaterials = () => {
    const now = new Date();
    const sortedMaterials = [...materiales].map((material) => {
      const processes = ['cubicacion', 'revCubicacion', 'solped', 'ocAprobada'];
      let nextProcess = 'dueDate';
      let nextProcessDate = new Date(material.dueDate);
      
      for (let process of processes) {
        const fileKey = `${material.id}-${process}`;
        if (!completedProcessesMateriales[fileKey]) {
          nextProcess = process;
          nextProcessDate = new Date(material[process]);
          break;
        }
      }
      
      const daysRemaining = Math.ceil((nextProcessDate - now) / (1000 * 60 * 60 * 24));
      
      return {
        ...material,
        nextProcess: nextProcess,
        nextProcessDate: nextProcessDate,
        daysUntilDue: daysRemaining,
      };
    }).sort((a, b) => a.daysUntilDue - b.daysUntilDue);
    
    return sortedMaterials.slice(0, 15);
  };

  // Función para enviar notificación por correo al equipo (usando Resend via backend)
  // eslint-disable-next-line no-unused-vars
  const enviarNotificacionEquipo = async () => {
    if (teamMembers.length === 0) {
      alert('⚠️ No hay miembros en el equipo para enviar notificaciones');
      return;
    }
    
    if (tasks.length === 0) {
      alert('⚠️ No hay subcontratos para incluir en la notificación');
      return;
    }

    const topTasks = getTopCriticalTasks().slice(0, 10);
    const topMaterials = getTopCriticalMaterials().slice(0, 10);
    const tablaHTML = generarTablaHTML(topTasks, projectName);
    const tablaMaterialesHTML = topMaterials.length > 0 ? generarTablaMaterialesHTML(topMaterials, projectName) : '';

    try {
      // Preparar destinatarios
      const destinatarios = teamMembers.map(member => ({
        name: member.name,
        email: member.email
      }));

      // Enviar al backend que usa Resend
      const response = await api.post('/notificaciones/enviar-correo', {
        destinatarios,
        projectName: projectName || 'Sin nombre',
        subcontratosHTML: tablaHTML,
        materialesHTML: tablaMaterialesHTML
      });

      const resultado = response.data;

      if (resultado.success) {
        alert(`✅ Notificación completada:\n\n- Enviados: ${resultado.enviados}/${destinatarios.length}\n- Remitente: benriveros@gestracoo.com`);
      } else {
        alert(`⚠️ Notificación completada con errores:\n\n- Enviados: ${resultado.enviados}\n- Errores: ${resultado.errores}\n\nDetalles en consola.`);
        console.error('⚠️ Errores en notificaciones:', resultado);
      }
    } catch (error) {
      console.error('❌ Error al enviar notificaciones:', error);
      alert(`❌ Error al enviar notificaciones:\n\n${error.message}`);
    }
  };

  const addTeamMember = async (e) => {
    e.preventDefault();
    if (!newMemberName.trim() || !newMemberEmail.trim() || !newMemberRole.trim()) return;
    
    setAddingMember(true);
    try {
      // Crear miembro en el backend
      const nuevoMiembro = await equipoService.agregarMiembro({
        name: newMemberName.trim(),
        email: newMemberEmail.trim(),
        role: newMemberRole.trim(),
      });
      
      // Agregar al estado local
      const newMember = {
        id: nuevoMiembro._id || Date.now(),
        name: newMemberName.trim(),
        email: newMemberEmail.trim(),
        role: newMemberRole.trim(),
        notificaciones: nuevoMiembro.notificaciones || { email: true, rutaCritica: true, subcontratosVencidos: true, nuevosProcesos: false, recepcion: true },
        dateAdded: new Date().toLocaleString('es-ES'),
      };
      
      setTeamMembers((prev) => [newMember, ...prev]);
      setNewMemberName('');
      setNewMemberEmail('');
      setNewMemberRole('');
      
      setAddingMember(false);
    } catch (error) {
      console.error('❌ Error al guardar miembro:', error);
      
      // Verificar si es error de email duplicado
      if (error.emailDuplicado || error.error === 'Email duplicado') {
        alert(`Este email ya está registrado en el equipo.\n\nEl email "${newMemberEmail}" ya pertenece a un miembro del equipo del proyecto.`);
      } else {
        alert('Error al guardar el miembro. Verifica que el backend esté corriendo y que hayas iniciado sesión.');
      }
      setAddingMember(false);
    }
  };

  // ==================== FUNCIONES PARA MATRIZ DE MATERIALES ====================
  
  const renderMaterialTableRows = () => {
    // Aplicar filtros
    // Usar materiales filtrados con useMemo (ya optimizado arriba)
    
    // Mantener orden estático de los materiales (sin ordenar por fecha)
    const sortedMaterials = [...materialesFiltrados];
    
    // Agrupa los materiales por sección (specialty)
    const grouped = {};
    sortedMaterials.forEach((material) => {
      if (!grouped[material.specialty]) {
        grouped[material.specialty] = [];
      }
      grouped[material.specialty].push(material);
    });
    
    // Mantener orden estático de las secciones de materiales (sin ordenar por fecha)
    const orderedSections = [...materialSections];
    
    // Agregar secciones que existen en materiales pero no en materialSections
    const specialtiesInUse = new Set(Object.keys(grouped));
    const existingSectionNames = new Set(materialSections.map(s => s.name));
    
    specialtiesInUse.forEach(specialty => {
      if (!existingSectionNames.has(specialty)) {
        // Crear sección temporal para materiales huérfanos
        orderedSections.push({
          id: `temp-${specialty}`,
          name: specialty
        });
      }
    });
    
    const rows = [];

    orderedSections.forEach((section) => {
      if (grouped[section.name]) {
        rows.push(
          <tr key={`section-${section.id}`} className="section-row">
            <td colSpan="11" className="section-header" style={{ position: 'relative' }}>
              {editSectionId === section.id ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px', paddingLeft: '20px' }}>
                  <input
                    type="text"
                    value={editSectionName}
                    onChange={e => setEditSectionName(e.target.value)}
                    style={{ fontWeight: 'bold', fontSize: '1.05rem', padding: '6px', borderRadius: '4px', border: '1px solid #374151' }}
                    disabled={isSavingSection}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && !isSavingSection) {
                        saveEditSectionMaterial(section.id);
                      } else if (e.key === 'Escape') {
                        cancelEditSection();
                      }
                    }}
                  />
                  <button 
                    className="add-button" 
                    style={{marginLeft:'8px'}} 
                    onClick={() => saveEditSectionMaterial(section.id)}
                    disabled={isSavingSection}
                  >
                    {isSavingSection ? 'Guardando...' : 'Guardar'}
                  </button>
                  <button 
                    className="delete-button" 
                    style={{marginLeft:'4px'}} 
                    onClick={cancelEditSection}
                    disabled={isSavingSection}
                  >
                    Cancelar
                  </button>
                  {sectionSaveError && (
                    <span style={{ 
                      marginLeft: '10px', 
                      color: '#dc2626', 
                      fontSize: '0.9rem',
                      fontWeight: 'normal'
                    }}>
                      {sectionSaveError}
                    </span>
                  )}
                </div>
              ) : (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px', paddingLeft: '20px' }}>
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '24px',
                      height: '24px',
                      cursor: 'pointer',
                      opacity: 0.7,
                      transition: 'opacity 0.2s, transform 0.2s',
                      borderRadius: '4px',
                      padding: '3px'
                    }}
                    onClick={() => startEditSection(section)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.opacity = '1';
                      e.currentTarget.style.transform = 'scale(1.1)';
                      e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.opacity = '0.7';
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    title="Editar nombre de sección"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#374151" width="18" height="18">
                      <path d="M15.85 6.15a.5.5 0 0 0 0-.7l-1.3-1.3a.5.5 0 0 0-.7 0l-8.1 8.1a.5.5 0 0 0-.13.24l-.7 2.8a.5.5 0 0 0 .61.61l2.8-.7a.5.5 0 0 0 .24-.13l8.1-8.1z"/>
                    </svg>
                  </span>
                  <span>{section.name}</span>
                </span>
              )}
            </td>
          </tr>
        );
        
        grouped[section.name].forEach((material) => {
          rows.push(
            <tr key={material.id} className={materialesSeleccionados.has(material.id) ? 'fila-seleccionada' : ''}>
              {/* Checkbox de selección */}
              <td className="checkbox-seleccion">
                <input
                  type="checkbox"
                  className="checkbox-seleccion-input"
                  checked={materialesSeleccionados.has(material.id)}
                  onChange={() => toggleMaterialSelection(material.id)}
                />
              </td>
              {/* Responsable */}
              <td style={{ textAlign: 'center', padding: '8px' }}>
                {renderResponsableAvatar(material, false)}
              </td>
              
              {/* Material */}
              <td>
                <strong>{material.text}</strong>
              </td>

              {/* Procesos - Renderizar según filtro activo */}
              {filtrosMateriales.proceso === 'todos' ? (
                <>
                  {renderMaterialProcessCell(material, 'inicio')}
                  {renderMaterialProcessCell(material, 'cubicacion')}
                  {renderMaterialProcessCell(material, 'revCubicacion')}
                  {renderMaterialProcessCell(material, 'solped')}
                  {renderMaterialProcessCell(material, 'ocAprobada')}
                  {renderMaterialProcessCell(material, 'materialEnObra')}
                </>
              ) : (
                renderMaterialProcessCell(material, filtrosMateriales.proceso)
              )}

              {/* Inicio de Partida */}
              <td className="due-date">
                {material.pendiente ? (
                  <button
                    type="button"
                    onClick={() => resolverMaterialPendiente(material)}
                    style={{ padding: '3px 10px', borderRadius: '999px', border: '1.5px solid #f59e0b', background: '#fffbeb', color: '#b45309', fontSize: '0.72rem', fontWeight: 700, cursor: 'pointer' }}
                    title="Elegir partida y/o sección"
                  >Pendiente</button>
                ) : (
                  <>
                    <strong>{formatDate(material.dueDate)}</strong>
                    {normalizarPartidas(material.partidaPrograma).length > 0 && (
                      <div style={{ fontSize: '0.68rem', color: '#6b7280', marginTop: 2, lineHeight: 1.2, fontWeight: 400 }}>
                        {normalizarPartidas(material.partidaPrograma).map(p => p.nombre).join(', ')}
                      </div>
                    )}
                  </>
                )}
              </td>

              {/* Acción */}
              <td>
                <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                  <button className="btn-editar-tabla" onClick={() => startEditMaterial(material)} title="Editar">✏</button>
                  <button
                    className="complete-button"
                    onClick={() => completeMaterial(material)}
                    disabled={isCompletingMaterial}
                  >
                    {isCompletingMaterial ? (
                      <span className="spinner"></span>
                    ) : (
                      'Completado'
                    )}
                  </button>
                  <button className="delete-button" onClick={() => removeMaterial(material.id)}>Eliminar</button>
                </div>
              </td>
            </tr>
          );
        });
      }
    });

    return rows;
  };

  // Función para guardar edición de sección en materiales
  const saveEditSectionMaterial = async (sectionId) => {
    if (isSavingSection) return; // Evitar múltiples guardados simultáneos
    
    const oldSectionName = materialSections.find(s => s.id === sectionId)?.name;
    
    // Validar que el nombre no esté vacío
    if (!editSectionName || !editSectionName.trim()) {
      setSectionSaveError('El nombre de la sección no puede estar vacío');
      return;
    }
    
    // Si el nombre no cambió, solo cerrar el modo edición
    if (oldSectionName === editSectionName.trim()) {
      setEditSectionId(null);
      return;
    }
    
    setIsSavingSection(true);
    setSectionSaveError(null);
    
    try {
      // Actualizar en el backend
      await seccionesMaterialesService.actualizarSeccion(sectionId, {
        nombre: editSectionName.trim()
      });

      // Actualizar el nombre de la sección de materiales en el estado local
      setMaterialSections((prev) => prev.map(s => 
        s.id === sectionId ? { ...s, name: editSectionName.trim() } : s
      ));
      
      // Actualizar los materiales que tienen esta especialidad
      if (oldSectionName && oldSectionName !== editSectionName.trim()) {
        setMateriales((prev) => prev.map(m => 
          m.specialty === oldSectionName ? { ...m, specialty: editSectionName.trim() } : m
        ));
      }
      
      // Recargar documentos de materiales para reflejar cambio de especialidad
      await cargarDocumentosMateriales();
      
      setEditSectionId(null);
      
      // Mostrar mensaje de éxito brevemente
      setTimeout(() => {
        setSectionSaveError(null);
      }, 3000);
      
    } catch (error) {
      console.error('❌ Error al guardar sección de material:', error);
      const mensajeError = error.mensaje || error.error || 'Error al actualizar la sección. Inténtalo de nuevo.';
      setSectionSaveError(mensajeError);
      
      // Limpiar error después de 5 segundos
      setTimeout(() => {
        setSectionSaveError(null);
      }, 5000);
    } finally {
      setIsSavingSection(false);
    }
  };
  
  const addMaterial = async (e) => {
    e.preventDefault();
    if (!materialText.trim() || !materialDueDate) return false;

    const inicioPartida = new Date(materialDueDate);
    
    // Función auxiliar para restar días a una fecha
    const restarDias = (fecha, dias) => {
      const result = new Date(fecha);
      result.setDate(result.getDate() - dias);
      return result.toISOString().split('T')[0];
    };

    // Calcular fechas restando días desde la fecha de inicio de partida
    // Material en Obra: inicio - días de Material en Obra
    const fechaMaterialEnObra = restarDias(inicioPartida, diasProcesosMateriales.materialEnObra);
    
    // OC Aprobada: Material en Obra - días de OC
    const fechaOcAprobada = restarDias(new Date(fechaMaterialEnObra), diasProcesosMateriales.ocAprobada);
    
    // Solped: OC Aprobada - días de Solped
    const fechaSolped = restarDias(new Date(fechaOcAprobada), diasProcesosMateriales.solped);
    
    // Rev Cubicación: Solped - días de Rev Cubicación
    const fechaRevCubicacion = restarDias(new Date(fechaSolped), diasProcesosMateriales.revCubicacion);
    
    // Cubicación: Rev Cubicación - días de Cubicación
    const fechaCubicacion = restarDias(new Date(fechaRevCubicacion), diasProcesosMateriales.cubicacion);
    
    // Inicio: Cubicación - días de Inicio
    const fechaInicio = restarDias(new Date(fechaCubicacion), diasProcesosMateriales.inicio);

    const newMaterial = {
      id: Date.now().toString(),
      text: materialText,
      specialty: materialSpecialty,
      dueDate: materialDueDate,
      inicio: fechaInicio,
      cubicacion: fechaCubicacion,
      revCubicacion: fechaRevCubicacion,
      solped: fechaSolped,
      ocAprobada: fechaOcAprobada,
      materialEnObra: fechaMaterialEnObra,
      createdAt: new Date().toISOString(),
      responsable: materialResponsable || null,
      partidaPrograma: partidaProgramaMaterial || null
    };

    try {
      // Verificar si la especialidad existe como sección, si no, crearla
      if (materialSpecialty && !materialSections.find(s => s.name === materialSpecialty)) {
        const nuevaSeccion = {
          id: Date.now().toString(),
          nombre: materialSpecialty
        };
        
        try {
          const seccionGuardada = await seccionesMaterialesService.crearSeccion(nuevaSeccion);
          setMaterialSections(prev => [...prev, {
            id: seccionGuardada._id,
            name: seccionGuardada.nombre
          }]);
        } catch (errorSeccion) {
          setMaterialSections(prev => [...prev, nuevaSeccion]);
        }
      }
      
      // Guardar en backend
      const respuesta = await materialesService.crearMaterial(newMaterial);
      
      // Extraer el material de la respuesta
      const materialGuardado = respuesta.material;
      
      // Formatear el material devuelto por el backend
      const materialFormateado = {
        id: materialGuardado._id, // Usar _id de MongoDB como id principal (igual que subcontratos)
        text: materialGuardado.text,
        specialty: materialGuardado.specialty,
        dueDate: new Date(materialGuardado.dueDate).toISOString().split('T')[0],
        inicio: materialGuardado.inicio ? new Date(materialGuardado.inicio).toISOString().split('T')[0] : fechaInicio,
        cubicacion: new Date(materialGuardado.cubicacion).toISOString().split('T')[0],
        revCubicacion: new Date(materialGuardado.revCubicacion).toISOString().split('T')[0],
        solped: new Date(materialGuardado.solped).toISOString().split('T')[0],
        ocAprobada: new Date(materialGuardado.ocAprobada).toISOString().split('T')[0],
        materialEnObra: materialGuardado.materialEnObra ? new Date(materialGuardado.materialEnObra).toISOString().split('T')[0] : materialGuardado.dueDate,
        partidaPrograma: materialGuardado.partidaPrograma || null,
        pendiente: materialGuardado.pendiente || false
      };

      setMateriales([...materiales, materialFormateado]);
      setMaterialText('');
      setMaterialSpecialty('');
      setMaterialDueDate('');
      setMaterialResponsable('');
      setPartidaProgramaMaterial([]);
      setModoDesdeProgamaMaterial(false);
      return true;
    } catch (error) {
      console.error('❌ Error completo:', error);
      console.error('❌ Respuesta del servidor:', error.response?.data);
      console.error('❌ Status:', error.response?.status);
      
      // Mostrar el error específico
      const errorMsg = error.response?.data?.mensaje || error.message || 'Error desconocido';
      alert(`Error al guardar el material: ${errorMsg}\n\n¿Deseas guardar solo localmente?`);
      
      // Guardar localmente de todos modos
      setMateriales([...materiales, newMaterial]);
      setMaterialText('');
      setMaterialSpecialty('');
      setMaterialDueDate('');
      setMaterialResponsable('');
      setPartidaProgramaMaterial([]);
      setModoDesdeProgamaMaterial(false);
      return true;
    }
  };

  const removeMaterial = async (id) => {
    try {
      await materialesService.eliminarMaterial(id);
      setMateriales((prev) => prev.filter((m) => m.id !== id));
    } catch (error) {
      // Si es error 404, el material ya no existe en el backend
      if (error.response && error.response.status === 404) {
        // Eliminar del estado local de todas formas
        setMateriales((prev) => prev.filter((m) => m.id !== id));
      } else {
        console.error('❌ Error al eliminar material:', error);
        alert('Error al eliminar el material.');
      }
    }
  };

  // ==================== FUNCIONES DE SELECCIÓN MÚLTIPLE - MATERIALES ====================
  
  // Toggle selección individual de material
  const toggleMaterialSelection = (materialId) => {
    setMaterialesSeleccionados(prev => {
      const newSet = new Set(prev);
      if (newSet.has(materialId)) {
        newSet.delete(materialId);
      } else {
        newSet.add(materialId);
      }
      return newSet;
    });
  };

  // Seleccionar todos los materiales visibles (filtrados)
  const selectAllMaterials = () => {
    const allVisibleIds = new Set(materialesFiltrados.map(m => m.id));
    setMaterialesSeleccionados(allVisibleIds);
  };

  // Deseleccionar todos los materiales
  const clearAllMaterialSelection = () => {
    setMaterialesSeleccionados(new Set());
  };

  // Verificar si todos los materiales visibles están seleccionados
  const allMaterialsSelected = materialesFiltrados.length > 0 && 
    materialesFiltrados.every(m => materialesSeleccionados.has(m.id));

  // Eliminar múltiples materiales seleccionados
  const removeSelectedMaterials = async () => {
    const cantidad = materialesSeleccionados.size;
    if (cantidad === 0) return;

    if (!window.confirm(`¿Estás seguro de eliminar ${cantidad} material${cantidad > 1 ? 'es' : ''} seleccionado${cantidad > 1 ? 's' : ''}?\n\nEsta acción no se puede deshacer.`)) {
      return;
    }

    setEliminandoSeleccionados(true);
    
    try {
      const idsArray = Array.from(materialesSeleccionados);
      let eliminados = 0;
      let errores = 0;

      for (const id of idsArray) {
        try {
          // Verificar si el material está completado
          const isCompleted = completedMateriales.some(m => m.id === id);
          
          if (isCompleted) {
            try {
              await materialesService.eliminarMaterialCompletado(id);
            } catch (error) {
              if (error.response?.status !== 404) throw error;
            }
            setCompletedMateriales((prev) => prev.filter((m) => m.id !== id));
          } else {
            try {
              await materialesService.eliminarMaterial(id);
            } catch (error) {
              if (error.response?.status !== 404) throw error;
            }
            setMateriales((prev) => prev.filter((m) => m.id !== id));
          }
          eliminados++;
        } catch (error) {
          console.error(`Error al eliminar material ${id}:`, error);
          errores++;
        }
      }

      // Limpiar selección
      setMaterialesSeleccionados(new Set());

      if (errores > 0) {
        alert(`Se eliminaron ${eliminados} materiales.\n${errores} no pudieron eliminarse.`);
      }
    } catch (error) {
      console.error('Error en eliminación masiva:', error);
      alert('Error durante la eliminación. Algunos elementos podrían no haberse eliminado.');
    } finally {
      setEliminandoSeleccionados(false);
    }
  };

  const completeMaterial = async (material) => {
    // Verificar que todos los procesos estén completados
    const processes = ['cubicacion', 'revCubicacion', 'solped', 'ocAprobada', 'materialEnObra'];
    const incompleteProcesses = [];
    
    for (let process of processes) {
      const fileKey = `${material.id}-${process}`;
      if (!completedProcessesMateriales[fileKey]) {
        incompleteProcesses.push(process);
      }
    }
    
    if (incompleteProcesses.length > 0) {
      const processNames = {
        'cubicacion': 'Cubicación',
        'revCubicacion': 'Rev. Cubicación',
        'solped': 'Solped',
        'ocAprobada': 'OC Aprobada',
        'materialEnObra': 'Material en Obra'
      };
      const missingNames = incompleteProcesses.map(p => processNames[p]).join(', ');
      alert(`❌ No se puede completar el material.\n\nDebe completar todos los procesos primero.\n\nProcesos faltantes: ${missingNames}`);
      return;
    }
    
    setIsCompletingMaterial(true);
    try {
      
      // Llamar al endpoint - devuelve el nuevo documento con su ID
      const respuesta = await materialesService.completarMaterial(material.id);
      const materialCompletadoBackend = respuesta.materialCompletado;
      
      // Usar el nuevo ID que devolvió el backend
      const materialCompletado = { 
        ...material, 
        id: materialCompletadoBackend.id, // Usar el nuevo ID de la colección materialescompletados
        completedAt: new Date().toISOString() 
      };
      
      setCompletedMateriales(prev => [materialCompletado, ...prev]);
      setMateriales((prev) => prev.filter((m) => m.id !== material.id));
      
    } catch (error) {
      // Si es error 404, el material ya no existe en el backend
      if (error.response && error.response.status === 404) {
        setMateriales((prev) => prev.filter((m) => m.id !== material.id));
      } else {
        console.error('❌ Error al completar material:', error);
        alert('Error al completar el material. Por favor, intenta de nuevo.');
      }
    } finally {
      setIsCompletingMaterial(false);
    }
  };

  const startEditMaterial = (material) => {
    setEditMaterialId(material.id);
    setEditMaterialFields({
      text: material.text,
      specialty: material.specialty || '',
      dueDate: material.dueDate ? new Date(material.dueDate).toISOString().split('T')[0] : '',
      partidaPrograma: normalizarPartidas(material.partidaPrograma)
    });
    setEditMatModoPrograma(normalizarPartidas(material.partidaPrograma).length > 0);
  };

  // Abre la edición de un material "Pendiente" directamente en modo "Desde Programa"
  // para que el usuario elija la partida (y/o sección) que falta resolver.
  const resolverMaterialPendiente = (material) => {
    startEditMaterial(material);
    setEditMatModoPrograma(true);
    if (actividadesMaterial.length === 0) {
      obtenerActividadesKpi().then(acts => {
        setActividadesMaterial(obtenerHojasProgramaDedup(acts));
        setActMapPrograma(construirActMapPrograma(acts));
      });
    }
  };

  const saveEditMaterial = async (materialId) => {
    try {
      // Actualizar en el backend
      const datosActualizados = {
        text: editMaterialFields.text,
        specialty: editMaterialFields.specialty,
        dueDate: editMaterialFields.dueDate,
        partidaPrograma: editMaterialFields.partidaPrograma,
        pendiente: false
      };

      const materialActualizado = await materialesService.actualizarMaterial(materialId, datosActualizados);

      // Actualizar estado local con las fechas recalculadas del backend
      setMateriales((prev) => prev.map((m) => {
        if (m.id === materialId) {
          return {
            ...m,
            text: materialActualizado.text,
            specialty: materialActualizado.specialty,
            dueDate: materialActualizado.dueDate,
            partidaPrograma: materialActualizado.partidaPrograma || null,
            pendiente: materialActualizado.pendiente || false,
            inicio: materialActualizado.inicio,
            cubicacion: materialActualizado.cubicacion,
            revCubicacion: materialActualizado.revCubicacion,
            solped: materialActualizado.solped,
            ocAprobada: materialActualizado.ocAprobada,
            materialEnObra: materialActualizado.materialEnObra
          };
        }
        return m;
      }));
      
      setEditMaterialId(null);
    } catch (error) {
      console.error('Error al guardar edición de material:', error);

      // Verificar error 403 de múltiples formas posibles
      const status = error.response?.status || error.status;
      const esError403 = status === 403;

      // Manejo especial para error 403 (sin permisos)
      if (esError403) {
        const data = error.response?.data || error.data || {};
        const adminInfo = data.administrador || 'el administrador';
        const mensaje = data.mensaje || 'No tienes permisos para modificar fechas';

        const alertMessage = `🚫 Acceso Denegado\n\n${mensaje}\n\n✅ Contacta a: ${adminInfo}`;
        alert(alertMessage);
      } else {
        const mensajeError = error.response?.data?.mensaje || error.mensaje || error.error || error.message || 'Error desconocido';
        alert('❌ Error al guardar los cambios: ' + mensajeError);
      }
    }
  };

  const cancelEditMaterial = () => {
    setEditMaterialId(null);
    setEditMatModoPrograma(false);
  };

  // Funciones para modal de materiales
  const openMaterialStageModal = async (material, stage) => {
    setSelectedMaterial(material);
    setSelectedMaterialStage(stage);
    setShowMaterialModal(true);
    
    // Cargar datos de precios si el proceso está completado
    const fileKey = `${material.id}-${stage}`;
    const procesoCompletado = completedProcessesMateriales[fileKey];
    if (procesoCompletado && stage === 'ocAprobada') {
      if (procesoCompletado.precioPresupuestado) {
        setPrecioPresupuestadoMaterial(procesoCompletado.precioPresupuestado.toString());
      }
      if (procesoCompletado.precioCierre) {
        setPrecioCierreMaterial(procesoCompletado.precioCierre.toString());
      }
    }
    
    // Cargar documentos existentes desde MongoDB (igual que en subcontratos)
    try {
      const documentos = await documentosMaterialesService.obtenerDocumentosMaterial(material.id);
      const docsDelProceso = documentos.filter(doc => doc.proceso === stage);
      
      if (docsDelProceso.length > 0) {
        const fileKey = `${material.id}-${stage}`;
        const archivosExistentes = docsDelProceso.map(doc => ({
          _id: doc._id,
          name: doc.nombre,
          size: doc.tamano,
          type: doc.mimeType,
          fromMongoDB: true
        }));
        
        setMaterialStageFiles(prev => ({
          ...prev,
          [fileKey]: archivosExistentes
        }));
        
        if (docsDelProceso[0]?.comentarios) {
          setMaterialStageComments(prev => ({
            ...prev,
            [fileKey]: [{
              id: Date.now(),
              text: docsDelProceso[0].comentarios,
              timestamp: new Date(docsDelProceso[0].createdAt).toLocaleString('es-ES')
            }]
          }));
        }
      }
    } catch (error) {
      console.error('❌ Error al cargar documentos de material:', error);
    }
  };

  const closeMaterialStageModal = () => {
    setShowMaterialModal(false);
    setSelectedMaterial(null);
    setSelectedMaterialStage(null);
    setMaterialProcessNoAplica(false); // Limpiar estado de "No aplica"
    setPrecioPresupuestadoMaterial(''); // Limpiar precio presupuestado
    setPrecioCierreMaterial(''); // Limpiar precio de cierre
    // NO limpiamos materialStageFiles ni materialStageComments
  };

  const handleMaterialFileUpload = (e) => {
    const files = e.target.files;
    if (files && selectedMaterial && selectedMaterialStage) {
      const fileKey = `${selectedMaterial.id}-${selectedMaterialStage}`;
      const fileList = Array.from(files);
      setMaterialStageFiles((prev) => ({
        ...prev,
        [fileKey]: [...(prev[fileKey] || []), ...fileList],
      }));
    }
  };

  const saveMaterialStageData = async () => {
    if (selectedMaterial && selectedMaterialStage && currentMaterialComment.trim()) {
      const fileKey = `${selectedMaterial.id}-${selectedMaterialStage}`;
      const newComment = {
        id: Date.now(),
        text: currentMaterialComment,
        timestamp: new Date().toLocaleString('es-ES'),
      };
      
      // Actualizar estado local
      const comentariosActualizados = [...(materialStageComments[fileKey] || []), newComment];
      setMaterialStageComments((prev) => ({
        ...prev,
        [fileKey]: comentariosActualizados,
      }));
      
      // Guardar comentario en el backend inmediatamente
      try {
        const comentariosTexto = comentariosActualizados.map(c => c.text).join('\n');
        await materialesService.actualizarProcesoMaterial(selectedMaterial.id, {
          proceso: selectedMaterialStage,
          completed: false, // No marcar como completado, solo guardar comentario
          files: [],
          comment: comentariosTexto,
          soloComentario: true // Indicar que solo se está guardando comentario
        });
      } catch (error) {
        console.error('❌ Error al guardar comentario de material:', error);
        alert('Error al guardar el comentario. Por favor intenta de nuevo.');
      }
      
      setCurrentMaterialComment('');
    }
  };

  const markMaterialProcessComplete = async () => {
    if (selectedMaterial && selectedMaterialStage) {
      const fileKey = `${selectedMaterial.id}-${selectedMaterialStage}`;
      const hasFiles = materialStageFiles[fileKey] && materialStageFiles[fileKey].length > 0;
      const hasComments = materialStageComments[fileKey] && materialStageComments[fileKey].length > 0;

      // Permitir completar si tiene archivos, comentarios o está marcado como "No aplica"
      if (hasFiles || hasComments || materialProcessNoAplica) {
        setIsSavingMaterialProcess(true);
        const timestamp = new Date().toLocaleString('es-ES');
        const completionData = {
          timestamp: timestamp,
          filesCount: hasFiles ? materialStageFiles[fileKey].length : 0,
          commentsCount: hasComments ? materialStageComments[fileKey].length : 0,
          noAplica: materialProcessNoAplica,
          precioPresupuestado: precioPresupuestadoMaterial ? parseFloat(precioPresupuestadoMaterial) : undefined,
          precioCierre: precioCierreMaterial ? parseFloat(precioCierreMaterial) : undefined
        };
        
        try {
          // Convertir solo archivos NUEVOS a base64 (los que no vienen de MongoDB)
          const archivosBase64 = [];
          if (hasFiles) {
            const archivosNuevos = materialStageFiles[fileKey].filter(f => !f.fromMongoDB);
            
            for (const file of archivosNuevos) {
              const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                  const result = reader.result.split(',')[1];
                  resolve(result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
              });
              
              archivosBase64.push({
                nombre: file.name,
                base64: base64,
                mimeType: file.type,
                tamano: file.size
              });
            }
          }
          
          // Preparar comentarios
          const comentariosTexto = hasComments 
            ? materialStageComments[fileKey].map(c => c.text).join('\n')
            : (materialProcessNoAplica ? 'N/A - No aplica' : '');
          
          // Preparar datos de precios si es OC Aprobada
          const datosPreciosMaterial = selectedMaterialStage === 'ocAprobada' ? {
            precioPresupuestado: precioPresupuestadoMaterial ? parseFloat(precioPresupuestadoMaterial) : undefined,
            precioCierre: precioCierreMaterial ? parseFloat(precioCierreMaterial) : undefined
          } : {};
          
          // Enviar al backend si hay archivos nuevos, comentarios o es "No aplica"
          if (archivosBase64.length > 0 || comentariosTexto || materialProcessNoAplica) {
            await materialesService.actualizarProcesoMaterial(selectedMaterial.id, {
              proceso: selectedMaterialStage,
              completed: true,
              files: hasFiles ? materialStageFiles[fileKey].map(f => f.name) : [],
              comment: comentariosTexto,
              archivos: archivosBase64,
              noAplica: materialProcessNoAplica,
              ...datosPreciosMaterial
            });
            
            
            // Recargar documentos de materiales desde MongoDB
            try {
              const proyectoId = localStorage.getItem('proyectoId');
              if (proyectoId) {
                const docsMat = await documentosMaterialesService.obtenerDocumentosProyecto(proyectoId);
                const docsMatArray = Array.isArray(docsMat) ? docsMat : [];
                setDocumentosMateriales(docsMatArray);
              }
            } catch (error) {
              console.error('Error al recargar documentos de materiales:', error);
            }
          }
          
          // Actualizar estado local DESPUÉS de guardar exitosamente
          setCompletedProcessesMateriales((prev) => ({
            ...prev,
            [fileKey]: completionData,
          }));
          
          closeMaterialStageModal();
        } catch (error) {
          console.error('❌ Error al guardar proceso de material:', error);
          alert('Error al guardar el proceso. Verifica la conexión con el backend.');
        } finally {
          setIsSavingMaterialProcess(false);
        }
      }
    }
  };

  const renderMaterialProcessCell = (material, stageName) => {
    const fileKey = `${material.id}-${stageName}`;
    const isCompleted = completedProcessesMateriales[fileKey];
    
    if (isCompleted) {
      return (
        <td 
          className="process-date completed-process" 
          onClick={() => openMaterialStageModal(material, stageName)} 
          style={{cursor: 'pointer'}}
          title={`Completado: ${isCompleted.filesCount} archivos, ${isCompleted.commentsCount} comentarios`}
        >
          <span className="process-ticket">
            ✓
          </span>
        </td>
      );
    }
    
    // Determinar si este es el próximo proceso pendiente
    const processes = ['inicio', 'cubicacion', 'revCubicacion', 'solped', 'ocAprobada', 'materialEnObra'];
    let isNextPending = false;
    
    for (let process of processes) {
      const fKey = `${material.id}-${process}`;
      if (!completedProcessesMateriales[fKey]) {
        isNextPending = (process === stageName);
        break;
      }
    }
    
    // Si es el proceso pendiente actual, calcular color según días restantes
    let cellStyle = { cursor: 'pointer' };
    let cellClassName = 'process-date';
    
    if (isNextPending) {
      const processDate = new Date(material[stageName]);
      const today = new Date();
      const daysLeft = Math.ceil((processDate - today) / (1000 * 60 * 60 * 24));
      
      if (daysLeft < 0) {
        // Vencido - Rojo
        cellClassName += ' process-critical';
      } else if (daysLeft <= 3) {
        // Por vencer (1-3 días) - Naranja
        cellClassName += ' process-urgent';
      } else if (daysLeft <= 7) {
        // Se acerca (4-7 días) - Amarillo
        cellClassName += ' process-warning';
      } else {
        // A tiempo (>7 días) - Verde
        cellClassName += ' process-good';
      }
    }
    
    return (
      <td 
        className={cellClassName}
        onClick={() => openMaterialStageModal(material, stageName)} 
        style={cellStyle}
      >
        {formatDate(material[stageName])}
      </td>
    );
  };

  const removeTeamMember = async (id) => {
    try {
      // Eliminar del backend (MongoDB)
      await equipoService.eliminarMiembro(id);
      
      // Actualizar el estado local
      setTeamMembers((prev) => prev.filter((member) => member.id !== id));
      
      alert('Miembro eliminado exitosamente');
    } catch (error) {
      console.error('Error al eliminar miembro:', error);
      alert('Error al eliminar el miembro: ' + (error.mensaje || error.error || 'Error desconocido'));
    }
  };

  // Función para actualizar el responsable de una subcontrato
  const updateTaskResponsable = async (taskId, responsableId) => {
    try {
      await subcontratosService.actualizarSubcontrato(taskId, { responsable: responsableId || null });
      
      // Actualizar estado local
      setTasks(prev => prev.map(task => {
        if (task.id === taskId) {
          // Si hay responsable, buscar el miembro para obtener los datos completos
          const miembro = responsableId ? teamMembers.find(m => m.id === responsableId) : null;
          return {
            ...task,
            responsable: miembro ? { _id: miembro.id, nombre: miembro.name, cargo: miembro.role } : null
          };
        }
        return task;
      }));
      
      setEditingResponsableTaskId(null);
    } catch (error) {
      console.error('❌ Error al actualizar responsable:', error);
      alert('Error al actualizar el responsable del subcontrato');
    }
  };

  // Función para actualizar el responsable de un material
  const updateMaterialResponsable = async (materialId, responsableId) => {
    try {
      await materialesService.actualizarMaterial(materialId, { responsable: responsableId || null });
      
      // Actualizar estado local
      setMateriales(prev => prev.map(material => {
        if (material.id === materialId) {
          // Si hay responsable, buscar el miembro para obtener los datos completos
          const miembro = responsableId ? teamMembers.find(m => m.id === responsableId) : null;
          return {
            ...material,
            responsable: miembro ? { _id: miembro.id, nombre: miembro.name, cargo: miembro.role } : null
          };
        }
        return material;
      }));
      
      setEditingResponsableMaterialId(null);
    } catch (error) {
      console.error('❌ Error al actualizar responsable:', error);
      alert('Error al actualizar el responsable del material');
    }
  };

  // Función para renderizar el avatar del responsable (clickeable para editar)
  const renderResponsableAvatar = (item, isTask = true) => {
    const responsable = item.responsable;
    const isEditing = isTask ? editingResponsableTaskId === item.id : editingResponsableMaterialId === item.id;
    
    // Si está en modo edición, mostrar dropdown
    if (isEditing) {
      return (
        <select
          value={responsable?._id || ''}
          onChange={(e) => {
            const newResponsableId = e.target.value;
            if (isTask) {
              updateTaskResponsable(item.id, newResponsableId);
            } else {
              updateMaterialResponsable(item.id, newResponsableId);
            }
          }}
          onBlur={() => {
            if (isTask) {
              setEditingResponsableTaskId(null);
            } else {
              setEditingResponsableMaterialId(null);
            }
          }}
          autoFocus
          style={{
            width: '120px',
            padding: '6px',
            borderRadius: '6px',
            border: '2px solid #374151',
            fontSize: '12px',
            cursor: 'pointer'
          }}
        >
          <option value="">Sin responsable</option>
          {teamMembers.map(member => (
            <option key={member.id} value={member.id}>
              {member.name}
            </option>
          ))}
        </select>
      );
    }
    
    // Avatar no editable (clickeable)
    if (!responsable || !responsable.nombre) {
      // Sin responsable - avatar gris con "?"
      return (
        <div
          className="responsable-avatar-empty"
          onClick={() => {
            if (isTask) {
              setEditingResponsableTaskId(item.id);
            } else {
              setEditingResponsableMaterialId(item.id);
            }
          }}
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            background: '#9ca3af',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px',
            fontWeight: '700',
            margin: '0 auto',
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            transition: 'transform 0.2s, box-shadow 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.1)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
          }}
          title="Click para asignar responsable"
        >
          ?
        </div>
      );
    }
    
    // Con responsable - avatar con color e inicial
    const memberIndex = teamMembers.findIndex(m => m.id === responsable._id);
    const colorIndex = memberIndex >= 0 ? memberIndex : 0;
    const inicial = responsable.nombre.charAt(0).toUpperCase();
    
    return (
      <div
        className="responsable-avatar-assigned"
        onClick={() => {
          if (isTask) {
            setEditingResponsableTaskId(item.id);
          } else {
            setEditingResponsableMaterialId(item.id);
          }
        }}
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          background: getAvatarColor(colorIndex),
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          fontWeight: '700',
          margin: '0 auto',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          transition: 'transform 0.2s, box-shadow 0.2s'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.3)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
        }}
        title={`${responsable.nombre} - ${responsable.cargo || 'Sin cargo'}\nClick para cambiar responsable`}
      >
        {inicial}
      </div>
    );
  };

  const renderProcessCell = (task, stageName) => {
    const fileKey = `${task.id}-${stageName}`;
    const isCompleted = completedProcesses[fileKey];
    
    if (isCompleted) {
      return (
        <td 
          className="process-date completed-process" 
          onClick={() => openStageModal(task, stageName)} 
          style={{cursor: 'pointer'}}
          title={`Completado: ${isCompleted.filesCount} archivos, ${isCompleted.commentsCount} comentarios`}
        >
          <span className="process-ticket">
            ✓
          </span>
        </td>
      );
    }
    
    // Determinar si este es el próximo proceso pendiente
    const processes = ['inicio', 'envios', 'comparativo', 'negociacion', 'precalificacion', 'contratoFirmado'];
    let isNextPending = false;
    
    for (let process of processes) {
      const fKey = `${task.id}-${process}`;
      if (!completedProcesses[fKey]) {
        isNextPending = (process === stageName);
        break;
      }
    }
    
    // Si es el proceso pendiente actual, calcular color según días restantes
    let cellStyle = { cursor: 'pointer' };
    let cellClassName = 'process-date';
    
    if (isNextPending) {
      const processDate = new Date(task[stageName]);
      const today = new Date();
      const daysLeft = Math.ceil((processDate - today) / (1000 * 60 * 60 * 24));
      
      if (daysLeft < 0) {
        // Vencido - Rojo
        cellClassName += ' process-critical';
      } else if (daysLeft <= 3) {
        // Por vencer (1-3 días) - Naranja
        cellClassName += ' process-urgent';
      } else if (daysLeft <= 7) {
        // Se acerca (4-7 días) - Amarillo
        cellClassName += ' process-warning';
      } else {
        // A tiempo (>7 días) - Verde
        cellClassName += ' process-good';
      }
    }
    
    return (
      <td 
        className={cellClassName}
        onClick={() => openStageModal(task, stageName)} 
        style={cellStyle}
      >
        {formatDate(task[stageName])}
      </td>
    );
  };

  // Función para manejar el inicio de sesión exitoso
  const handleInicioSesionExitoso = (resultado) => {
    localStorage.setItem('ultimaActividad', Date.now().toString());

    // Multi-proyecto: cargar lista y activo
    if (resultado.proyectos) {
      setProyectos(resultado.proyectos);
    }
    const activo = resultado.proyectoActivo || resultado.proyecto;
    if (activo) {
      setProyectoActivo(activo);
      setProjectName(activo.nombre);
      setProjectManager(activo.manager || '');
      if (activo.appsVisibles) setAppsVisibles(activo.appsVisibles);
    }

    // Guardar datos del usuario
    if (resultado.usuario) {
      setProjectUser(resultado.usuario.email);
      setUsuarioActual(resultado.usuario);
    }

    // Redirigir según tipo de usuario al iniciar sesión
    if (resultado.usuario?.tipoUsuario === 'propietario' || resultado.usuario?.tipoUsuario === 'gerente') {
      setActiveTab('dashboard-global');
    } else if (resultado.usuario?.tipoUsuario === 'miembro') {
      setActiveTab('proyecto-resumen');
    }

    // Actualizar estado de login
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', 'true');
  };

  // Recargar todos los datos cuando se cambia de proyecto
  const recargarDatosProyecto = async (proyecto) => {
    // Id del proyecto para el que se está ejecutando esta recarga. Si el usuario
    // vuelve a cambiar de proyecto mientras estas peticiones siguen en vuelo,
    // proyectoVigenteRef.current dejará de coincidir y las respuestas tardías
    // se descartan en vez de sobreescribir el estado del proyecto realmente activo.
    const idProyectoDeEstaCarga = proyecto._id || proyecto.id;

    // Actualizar configuración del proyecto con los datos disponibles
    if (proyecto.diasProcesos) {
      setProcessDays({
        inicio: proyecto.diasProcesos.inicio ?? 3,
        envios: proyecto.diasProcesos.envios ?? 7,
        comparativo: proyecto.diasProcesos.comparativo ?? 7,
        negociacion: proyecto.diasProcesos.negociacion ?? 7,
        precalificacion: proyecto.diasProcesos.precalificacion ?? 7,
        contratoFirmado: proyecto.diasProcesos.contratoFirmado ?? 7
      });
    }
    if (proyecto.diasProcesosMateriales) {
      setDiasProcesosMateriales({
        inicio: proyecto.diasProcesosMateriales.inicio ?? 7,
        cubicacion: proyecto.diasProcesosMateriales.cubicacion ?? 10,
        revCubicacion: proyecto.diasProcesosMateriales.revCubicacion ?? 7,
        solped: proyecto.diasProcesosMateriales.solped ?? 5,
        ocAprobada: proyecto.diasProcesosMateriales.ocAprobada ?? 14,
        materialEnObra: proyecto.diasProcesosMateriales.materialEnObra ?? 7
      });
    }
    if (proyecto.fechaRecepcionPrograma !== undefined || proyecto.fechaRecepcionEsperada !== undefined) {
      setFechasRecepcion({
        fechaRecepcionPrograma: proyecto.fechaRecepcionPrograma ? proyecto.fechaRecepcionPrograma.split('T')[0] : '',
        fechaRecepcionEsperada: proyecto.fechaRecepcionEsperada ? proyecto.fechaRecepcionEsperada.split('T')[0] : '',
        mesesRecepcion: proyecto.mesesRecepcion ?? 0,
      });
    }

    // Resetear todos los datos del proyecto anterior
    setTasks([]);
    setCompletedTasks([]);
    setCompletedProcesses({});
    setSections([]);
    setMateriales([]);
    setCompletedMateriales([]);
    setCompletedProcessesMateriales({});
    setMaterialSections([]);
    setTeamMembers([]);
    setCertificados([]);
    setCertificadosCompletados([]);
    setSeccionesRecepcion([]);
    setDocumentosSubcontratos([]);
    setDocumentosMateriales([]);

    try {
      // Cargar subcontratos activas
      const subcontratosBackend = await subcontratosService.obtenerSubcontratos(false);
      if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
      if (subcontratosBackend && subcontratosBackend.length > 0) {
        const subcontratosFormateados = subcontratosBackend.map(t => {
          const processDates = t.envios
            ? { inicio: t.inicio, envios: t.envios, comparativo: t.comparativo, negociacion: t.negociacion, precalificacion: t.precalificacion, contratoFirmado: t.contratoFirmado }
            : calculateAllProcessDates(t.fechaEntrega);
          return {
            id: t._id, text: t.texto, madeBy: t.hechoPor, specialty: t.especialidad,
            dueDate: t.fechaEntrega, section: t.seccion, responsable: t.responsable,
            partidaPrograma: t.partidaPrograma || null,
            pendiente: t.pendiente || false,
            inicio: processDates.inicio, envios: processDates.envios, comparativo: processDates.comparativo,
            negociacion: processDates.negociacion, precalificacion: processDates.precalificacion,
            contratoFirmado: processDates.contratoFirmado
          };
        });
        setTasks(subcontratosFormateados);

        const procesosCompletadosMap = {};
        subcontratosBackend.forEach(t => {
          if (t.procesosCompletados) {
            const procesos = t.procesosCompletados instanceof Map ? Object.fromEntries(t.procesosCompletados) : t.procesosCompletados;
            Object.entries(procesos).forEach(([etapa, datos]) => {
              procesosCompletadosMap[`${t._id}-${etapa}`] = {
                timestamp: datos.marcaTiempo, filesCount: datos.cantidadArchivos || 0,
                commentsCount: datos.cantidadComentarios || 0, noAplica: datos.noAplica || false,
                precioPresupuestado: datos.precioPresupuestado, precioCierre: datos.precioCierre
              };
            });
          }
        });
        if (Object.keys(procesosCompletadosMap).length > 0) setCompletedProcesses(procesosCompletadosMap);
      }

      // Cargar subcontratos completadas
      const subcontratosCompletadosBackend = await subcontratosService.obtenerSubcontratosCompletados();
      if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
      if (subcontratosCompletadosBackend && subcontratosCompletadosBackend.length > 0) {
        const subcontratosCompletadosFormateados = subcontratosCompletadosBackend.map(t => {
          const processDates = t.envios
            ? { inicio: t.inicio, envios: t.envios, comparativo: t.comparativo, negociacion: t.negociacion, precalificacion: t.precalificacion, contratoFirmado: t.contratoFirmado }
            : calculateAllProcessDates(t.fechaEntrega);
          return {
            id: t._id, text: t.texto, madeBy: t.hechoPor, specialty: t.especialidad,
            dueDate: t.fechaEntrega, section: t.seccion, completedDate: t.fechaCompletada,
            inicio: processDates.inicio, envios: processDates.envios, comparativo: processDates.comparativo,
            negociacion: processDates.negociacion, precalificacion: processDates.precalificacion,
            contratoFirmado: processDates.contratoFirmado
          };
        });
        setCompletedTasks(subcontratosCompletadosFormateados);
      }

      // Cargar secciones de subcontratos y materiales, miembros del equipo en paralelo
      const [seccionesSubcontratosBackend, seccionesMaterialesBackend, miembrosBackend] = await Promise.all([
        seccionesSubcontratosService.obtenerSecciones(),
        seccionesMaterialesService.obtenerSecciones(),
        equipoService.obtenerMiembros(true)
      ]);
      if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;

      if (seccionesSubcontratosBackend && seccionesSubcontratosBackend.length > 0) {
        setSections(seccionesSubcontratosBackend.map(s => ({ id: s._id, name: s.nombre })));
      }
      if (seccionesMaterialesBackend && seccionesMaterialesBackend.length > 0) {
        setMaterialSections(seccionesMaterialesBackend.map(s => ({ id: s._id, name: s.nombre })));
      }
      if (miembrosBackend && miembrosBackend.length > 0) {
        setTeamMembers(miembrosBackend.map(m => ({
          id: m._id, name: m.nombre, email: m.email, role: m.cargo, cargo: m.cargo,
          usuario: m.usuario, notificaciones: m.notificaciones || {},
          dateAdded: new Date(m.createdAt).toLocaleString('es-ES')
        })));
      }

      // Cargar materiales activos
      const materialesBackend = await materialesService.obtenerMateriales();
      if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
      if (materialesBackend && materialesBackend.length > 0) {
        setMateriales(materialesBackend.map(m => ({
          id: m._id, text: m.text, specialty: m.specialty || '', dueDate: m.dueDate,
          responsable: m.responsable, partidaPrograma: m.partidaPrograma || null,
          pendiente: m.pendiente || false,
          inicio: m.inicio, cubicacion: m.cubicacion,
          revCubicacion: m.revCubicacion, solped: m.solped, ocAprobada: m.ocAprobada,
          materialEnObra: m.materialEnObra || m.dueDate, createdAt: m.createdAt
        })));

        const procesosCompletadosMat = {};
        materialesBackend.forEach(m => {
          if (m.procesosCompletados) {
            const procesos = m.procesosCompletados instanceof Map ? Object.fromEntries(m.procesosCompletados) : m.procesosCompletados;
            Object.entries(procesos).forEach(([proceso, datos]) => {
              procesosCompletadosMat[`${m._id}-${proceso}`] = {
                timestamp: datos.marcaTiempo || new Date().toISOString(),
                filesCount: datos.cantidadArchivos || 0, commentsCount: datos.cantidadComentarios || 0,
                noAplica: datos.noAplica || false, precioPresupuestado: datos.precioPresupuestado,
                precioCierre: datos.precioCierre
              };
            });
          }
        });
        if (Object.keys(procesosCompletadosMat).length > 0) setCompletedProcessesMateriales(procesosCompletadosMat);
      }

      // Cargar materiales completados
      const materialesCompletadosBackend = await materialesService.obtenerMaterialesCompletados();
      if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
      if (materialesCompletadosBackend && materialesCompletadosBackend.materiales && materialesCompletadosBackend.materiales.length > 0) {
        setCompletedMateriales(materialesCompletadosBackend.materiales.map(m => ({
          id: m._id, text: m.texto, specialty: m.especialidad || '', dueDate: m.fechaInicio,
          inicio: m.procesos?.inicio, cubicacion: m.procesos?.cubicacion,
          revCubicacion: m.procesos?.revCubicacion, solped: m.procesos?.solped,
          ocAprobada: m.procesos?.ocAprobada, completedAt: m.fechaCompletada
        })));
      }

      // Cargar RECEPCIÓN
      try {
        const certsBackend = await certificadosService.obtenerCertificados();
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
        if (certsBackend && certsBackend.length > 0) {
          setCertificados(certsBackend.map(c => ({
            id: c._id, nombrePartida: c.nombrePartida || '', especialidad: c.especialidad || '',
            terminoPartida: c.terminoPartida ? c.terminoPartida.split('T')[0] : '',
            documentos: (c.documentos || []).map(doc => ({
              id: doc._id, nombre: doc.nombre || '',
              fechaProgramada: doc.fechaProgramada ? doc.fechaProgramada.split('T')[0] : '',
              fechaEsperada: doc.fechaEsperada ? doc.fechaEsperada.split('T')[0] : '',
              archivos: doc.archivos || [], observaciones: doc.observaciones || '',
              completado: doc.completado || false,
              fechaCompletado: doc.fechaCompletado ? doc.fechaCompletado.split('T')[0] : ''
            })),
            responsable: c.responsable ? c.responsable._id || c.responsable : '',
            responsables: (c.responsables || []).map(r => r._id || r),
            responsablesExternos: c.responsablesExternos || []
          })));
        }
        const certsCompBackend = await certificadosService.obtenerCompletados();
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
        if (certsCompBackend && certsCompBackend.length > 0) {
          setCertificadosCompletados(certsCompBackend.map(c => ({
            id: c._id, nombrePartida: c.nombrePartida || '', especialidad: c.especialidad || '',
            terminoPartida: c.terminoPartida ? c.terminoPartida.split('T')[0] : '',
            documentos: (c.documentos || []).map(doc => ({
              id: doc._id, nombre: doc.nombre || '',
              fechaProgramada: doc.fechaProgramada ? doc.fechaProgramada.split('T')[0] : '',
              fechaEsperada: doc.fechaEsperada ? doc.fechaEsperada.split('T')[0] : '',
              archivos: doc.archivos || [], observaciones: doc.observaciones || '',
              completado: doc.completado || false,
              fechaCompletado: doc.fechaCompletado ? doc.fechaCompletado.split('T')[0] : ''
            })),
            fechaReal: c.fechaReal ? c.fechaReal.split('T')[0] : '',
            responsable: c.responsable ? (typeof c.responsable === 'object' ? c.responsable.nombre : c.responsable) : '',
            responsables: (c.responsables || []).map(r => typeof r === 'object' ? r.nombre : r),
            responsablesExternos: c.responsablesExternos || []
          })));
        }
        const seccionesRecepcionBackend = await certificadosService.obtenerSecciones();
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
        if (seccionesRecepcionBackend && seccionesRecepcionBackend.length > 0) {
          setSeccionesRecepcion(seccionesRecepcionBackend.map(s => ({ id: s._id, name: s.nombre })));
        }
      } catch (errCert) {
        console.error('⚠️ Error al recargar RECEPCIÓN:', errCert);
      }

      // Cargar documentos de subcontratos y materiales del nuevo proyecto
      try {
        const responseSub = await api.get('/documentos');
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
        setDocumentosSubcontratos(Array.isArray(responseSub.data) ? responseSub.data : []);

        const docsMat = await documentosMaterialesService.obtenerDocumentosProyecto();
        if (proyectoVigenteRef.current !== idProyectoDeEstaCarga) return;
        setDocumentosMateriales(Array.isArray(docsMat) ? docsMat : []);
      } catch (errDocs) {
        console.error('⚠️ Error al recargar documentos:', errDocs);
      }

    } catch (error) {
      console.error('❌ Error al recargar datos del proyecto:', error);
    }
  };

  // Cambiar proyecto activo desde el Sidebar
  const handleCambiarProyecto = (proyecto) => {
    invalidarCachePrograma();
    proyectoVigenteRef.current = proyecto._id || proyecto.id;
    authService.cambiarProyectoActivo(proyecto);
    setProyectoActivo(proyecto);
    setProjectName(proyecto.nombre);
    setProjectManager(proyecto.manager || '');
    if (proyecto.appsVisibles) setAppsVisibles(proyecto.appsVisibles);
    const tabsGlobales = ['dashboard-global', 'proyectos-equipo', 'global-equipo'];
    if (tabsGlobales.includes(activeTab)) setActiveTab('proyecto-resumen');
    recargarDatosProyecto(proyecto);
  };

  // Eliminar proyecto desde la Vista Global
  const handleEliminarProyecto = async (proyectoId) => {
    await authService.eliminarProyecto(proyectoId);
    const listaActualizada = proyectos.filter(p => (p._id || p.id) !== proyectoId);
    setProyectos(listaActualizada);
    localStorage.setItem('proyectos', JSON.stringify(listaActualizada));
    // Si era el proyecto activo, cambiar al primero disponible
    const activoId = proyectoActivo?._id || proyectoActivo?.id;
    if (activoId === proyectoId && listaActualizada.length > 0) {
      handleCambiarProyecto(listaActualizada[0]);
    }
  };

  // Crear nuevo proyecto desde el modal
  const handleCrearProyecto = async (nombre, manager, descripcion, aplicarPlantilla) => {
    const response = await authService.crearProyecto(nombre, manager, descripcion, aplicarPlantilla);
    const nuevo = response.proyecto;
    const listaActualizada = [...proyectos, nuevo];
    setProyectos(listaActualizada);
    localStorage.setItem('proyectos', JSON.stringify(listaActualizada));
    handleCambiarProyecto(nuevo);
    return nuevo;
  };

  // ==================== RECARGAR DATOS POST-IMPORTACIÓN EXCEL ====================
  const handleImportComplete = async (resultado) => {
    try {
      // Recargar subcontratos activas
      const subcontratosBackend = await subcontratosService.obtenerSubcontratos(false);
      if (subcontratosBackend && subcontratosBackend.length > 0) {
        const subcontratosFormateados = subcontratosBackend.map(t => {
          const processDates = t.envios 
            ? { inicio: t.inicio, envios: t.envios, comparativo: t.comparativo, negociacion: t.negociacion, precalificacion: t.precalificacion, contratoFirmado: t.contratoFirmado }
            : calculateAllProcessDates(t.fechaEntrega);
          return {
            id: t._id, text: t.texto, madeBy: t.hechoPor, specialty: t.especialidad,
            dueDate: t.fechaEntrega, section: t.seccion, responsable: t.responsable,
            partidaPrograma: t.partidaPrograma || null,
            pendiente: t.pendiente || false,
            ...processDates
          };
        });
        setTasks(subcontratosFormateados);
      }

      // Recargar materiales
      const materialesBackend = await materialesService.obtenerMateriales();
      if (materialesBackend && materialesBackend.length > 0) {
        const materialesFormateados = materialesBackend.map(m => ({
          id: m._id, text: m.text, specialty: m.specialty || '',
          dueDate: m.dueDate, responsable: m.responsable,
          partidaPrograma: m.partidaPrograma || null,
          pendiente: m.pendiente || false,
          inicio: m.inicio, cubicacion: m.cubicacion, revCubicacion: m.revCubicacion,
          solped: m.solped, ocAprobada: m.ocAprobada,
          materialEnObra: m.materialEnObra || m.dueDate, createdAt: m.createdAt
        }));
        setMateriales(materialesFormateados);
      }

      // Recargar secciones de subcontratos
      const seccionesSubcontratosBackend = await seccionesSubcontratosService.obtenerSecciones();
      if (seccionesSubcontratosBackend && seccionesSubcontratosBackend.length > 0) {
        setSections(seccionesSubcontratosBackend.map(s => ({ id: s._id, name: s.nombre })));
      }

      // Recargar secciones de materiales
      const seccionesMaterialesBackend = await seccionesMaterialesService.obtenerSecciones();
      if (seccionesMaterialesBackend && seccionesMaterialesBackend.length > 0) {
        setMaterialSections(seccionesMaterialesBackend.map(s => ({ id: s._id, name: s.nombre })));
      }

    } catch (error) {
      console.error('❌ Error al recargar datos post-importación:', error);
    }
  };

  // Mostrar loading mientras verifica autenticación
  if (isCheckingAuth) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#0f172a',
        color: '#fff'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="spinner" style={{
            width: '50px',
            height: '50px',
            border: '4px solid rgba(59, 130, 246, 0.3)',
            borderTop: '4px solid #374151',
            borderRadius: '50%',
            margin: '0 auto 20px',
            animation: 'spin 1s linear infinite'
          }}></div>
          <p style={{ fontSize: '18px', color: '#94a3b8' }}>Cargando...</p>
        </div>
      </div>
    );
  }
  
  // Pantalla de Login
  if (!isLoggedIn) {
    return <Login alIniciarSesion={handleInicioSesionExitoso} />;
  }

  const modoGlobal = activeTab === 'dashboard-global' || activeTab === 'proyectos-equipo' || activeTab === 'global-equipo'
    || (activeTab === 'configuracion' && vinoDeVistaGlobal);

  return (
    <div className="App">
      {hayActualizacion && <AvisoActualizacion onRecargar={recargarAhora} />}
      <div className="app-container">
        {/* SIDEBAR CON PESTAÑAS */}
        <Sidebar
          activeTab={activeTab} setActiveTab={setActiveTab}
          projectName={projectName} projectUser={projectUser}
          projectManager={projectManager} teamMembers={teamMembers}
          usuarioActual={usuarioActual} appsVisibles={appsVisibles}
          proyectos={proyectos}
          proyectoActivo={proyectoActivo}
          onCambiarProyecto={handleCambiarProyecto}
          onNuevoProyecto={() => setShowModalNuevoProyecto(true)}
          modoGlobal={modoGlobal}
          onLogout={handleLogout}
        />

        {/* CONTENIDO PRINCIPAL */}
        <main className="main-content">
          <header className="main-header">
            <section className="hero">
            </section>
          </header>

          {/* TAB: MATRIZ DE SUBCONTRATO */}
          {activeTab === 'matriz' && (
            <TabMatrizSubcontrato
              tasks={tasks} materiales={materiales} sections={sections}
              materialSections={materialSections} teamMembers={teamMembers}
              showConfigDays={showConfigDays} setShowConfigDays={setShowConfigDays}
              showTaskForm={showTaskForm} setShowTaskForm={setShowTaskForm}
              filtrosBusqueda={filtrosBusqueda} setFiltrosBusqueda={setFiltrosBusqueda}
              processDays={processDays} setProcessDays={setProcessDays}
              handleSaveProcessDays={handleSaveProcessDays} savingConfig={savingConfig}
              specialty={specialty} setSpecialty={setSpecialty}
              taskText={taskText} setTaskText={setTaskText} dueDate={dueDate} setDueDate={setDueDate}
              addTask={addTask}
              modoDesdePrograma={modoDesdePrograma} setModoDesdePrograma={setModoDesdePrograma}
              actividadesSubcontrato={actividadesSubcontrato} setActividadesSubcontrato={setActividadesSubcontrato}
              partidaPrograma={partidaPrograma} setPartidaPrograma={setPartidaPrograma}
              actMapPrograma={actMapPrograma} setActMapPrograma={setActMapPrograma}
              obtenerActividadesKpi={obtenerActividadesKpi}
              nombresPlantillas={nombresPlantillas} cargarNombresPlantillas={cargarNombresPlantillas}
              mostrarSugerenciasSubcontrato={mostrarSugerenciasSubcontrato} setMostrarSugerenciasSubcontrato={setMostrarSugerenciasSubcontrato}
              subcontratosFiltrados={subcontratosFiltrados} renderTableRows={renderTableRows}
              handleImportComplete={handleImportComplete}
              allTasksSelected={allTasksSelected} selectAllTasks={selectAllTasks} clearAllTaskSelection={clearAllTaskSelection}
              editTaskId={editTaskId} editFields={editFields} setEditFields={setEditFields}
              editTaskModoPrograma={editTaskModoPrograma} setEditTaskModoPrograma={setEditTaskModoPrograma}
              saveEditTask={saveEditTask} cancelEditTask={cancelEditTask}
            />
          )}

        {/* TAB: DOCUMENTOS */}
        {activeTab === 'documentos' && (
          <TabDocumentos
            documentosSubcontratos={documentosSubcontratos}
            documentosMateriales={documentosMateriales}
            expandedSectionsSubcontratos={expandedSectionsSubcontratos}
            expandedSectionsMateriales={expandedSectionsMateriales}
            toggleSeccionSubcontrato={toggleSeccionSubcontrato}
            toggleSeccionMateriales={toggleSeccionMateriales}
            expandirTodasSubcontratos={expandirTodasSubcontratos}
            colapsarTodasSubcontratos={colapsarTodasSubcontratos}
            expandirTodasMateriales={expandirTodasMateriales}
            colapsarTodasMateriales={colapsarTodasMateriales}
            agruparDocumentosPorSeccion={agruparDocumentosPorSeccion}
            eliminarDocumentosSubcontrato={eliminarDocumentosSubcontrato}
            eliminarDocumentosMaterial={eliminarDocumentosMaterial}
          />
        )}

        {/* TAB: PROYECTO */}
        {activeTab === 'proyecto' && (
          <TabProyecto
            projectName={projectName} setProjectName={setProjectName}
            projectManager={projectManager} setProjectManager={setProjectManager}
            projectUser={projectUser} setProjectUser={setProjectUser}
            propietarioEmail={propietarioEmail}
            showProjectForm={showProjectForm} setShowProjectForm={setShowProjectForm}
            isEditingProject={isEditingProject} setIsEditingProject={setIsEditingProject}
            handleSaveProject={handleSaveProject}
          />
        )}



        {/* TAB: CONFIGURACIÓN */}
        {activeTab === 'configuracion' && (
          <TabConfiguracion
            usuarioActual={usuarioActual}
            handleActualizarUsuario={handleActualizarUsuario}
            showSavedPassword={showSavedPassword}
            setShowSavedPassword={setShowSavedPassword}
            teamMembers={teamMembers}
            onEmailCambiado={(nuevoEmail) => setUsuarioActual(prev => ({ ...prev, email: nuevoEmail }))}
          />
        )}



        {/* TAB: MATRIZ DE MATERIALES */}
        {activeTab === 'materiales' && (
          <TabMatrizMateriales
            tasks={tasks} materiales={materiales} sections={sections}
            materialSections={materialSections} teamMembers={teamMembers}
            showConfigMateriales={showConfigMateriales} setShowConfigMateriales={setShowConfigMateriales}
            showMaterialForm={showMaterialForm} setShowMaterialForm={setShowMaterialForm}
            filtrosMateriales={filtrosMateriales} setFiltrosMateriales={setFiltrosMateriales}
            diasProcesosMateriales={diasProcesosMateriales} setDiasProcesosMateriales={setDiasProcesosMateriales}
            handleSaveProcessDaysMateriales={handleSaveProcessDaysMateriales}
            savingConfigMateriales={savingConfigMateriales}
            materialText={materialText} setMaterialText={setMaterialText}
            materialSpecialty={materialSpecialty} setMaterialSpecialty={setMaterialSpecialty}
            materialDueDate={materialDueDate} setMaterialDueDate={setMaterialDueDate}
            addMaterial={addMaterial}
            modoDesdeProgamaMaterial={modoDesdeProgamaMaterial} setModoDesdeProgamaMaterial={setModoDesdeProgamaMaterial}
            actividadesMaterial={actividadesMaterial} setActividadesMaterial={setActividadesMaterial}
            partidaProgramaMaterial={partidaProgramaMaterial} setPartidaProgramaMaterial={setPartidaProgramaMaterial}
            actMapPrograma={actMapPrograma} setActMapPrograma={setActMapPrograma}
            obtenerActividadesKpi={obtenerActividadesKpi}
            nombresPlantillas={nombresPlantillas} cargarNombresPlantillas={cargarNombresPlantillas}
            mostrarSugerenciasMaterial={mostrarSugerenciasMaterial} setMostrarSugerenciasMaterial={setMostrarSugerenciasMaterial}
            materialesFiltrados={materialesFiltrados} renderMaterialTableRows={renderMaterialTableRows}
            handleImportComplete={handleImportComplete}
            allMaterialsSelected={allMaterialsSelected} selectAllMaterials={selectAllMaterials}
            clearAllMaterialSelection={clearAllMaterialSelection}
            editMaterialId={editMaterialId} editMaterialFields={editMaterialFields} setEditMaterialFields={setEditMaterialFields}
            editMatModoPrograma={editMatModoPrograma} setEditMatModoPrograma={setEditMatModoPrograma}
            saveEditMaterial={saveEditMaterial} cancelEditMaterial={cancelEditMaterial}
          />
        )}






          {/* TAB: EQUIPO */}
          {activeTab === 'equipo' && (
            <TabEquipo
              teamMembers={teamMembers}
              showTeamForm={showTeamForm} setShowTeamForm={setShowTeamForm}
              newMemberName={newMemberName} setNewMemberName={setNewMemberName}
              newMemberEmail={newMemberEmail} setNewMemberEmail={setNewMemberEmail}
              newMemberRole={newMemberRole} setNewMemberRole={setNewMemberRole}
              addTeamMember={addTeamMember} removeTeamMember={removeTeamMember} addingMember={addingMember}
            />
          )}



          {/* TAB: RESUMEN PROYECTO */}
          {activeTab === 'proyecto-resumen' && (
            <TabResumenProyecto
              tasks={tasks}
              completedTasks={completedTasks}
              materiales={materiales}
              completedMateriales={completedMateriales}
              certificados={certificados}
              fechasRecepcion={fechasRecepcion}
              sections={sections}
              materialSections={materialSections}
              seccionesRecepcion={seccionesRecepcion}
              getTopCriticalTasks={getTopCriticalTasks}
              getTopCriticalMaterials={getTopCriticalMaterials}
              onIrAModulo={(modulo) => {
                if (modulo === 'gestracoo') setActiveTab('dashboard');
                else if (modulo === 'materiales') setActiveTab('materiales');
                else if (modulo === 'programa') setActiveTab('programa-dashboard');
                else setActiveTab('recepcion-matriz');
              }}
            />
          )}

          {/* TAB: DASHBOARD */}
          {activeTab === 'dashboard' && (
            <Dashboard
              key={proyectoActivo?._id || proyectoActivo?.id}
              getTopCriticalTasks={getTopCriticalTasks}
              getTopCriticalMaterials={getTopCriticalMaterials}
            />
          )}

          {/* TAB: PROGRESO */}
          {activeTab === 'progreso' && (
            <TabProgreso
              tasks={tasks} materiales={materiales}
              completedTasks={completedTasks} completedMateriales={completedMateriales}
              setCompletedMateriales={setCompletedMateriales}
              restoreCompletedTask={restoreCompletedTask} deleteCompletedTask={deleteCompletedTask}
              restoreCompletedMaterial={restoreCompletedMaterial}
            />
          )}



        {/* TAB: RECEPCIÓN - MATRIZ DE RECEPCION */}
        {activeTab === 'recepcion-matriz' && (
          <MatrizRecepcion
            certificados={certificados}
            secciones={seccionesRecepcion}
            miembrosEquipo={teamMembers}
            fechasRecepcion={fechasRecepcion}
            mesesRecepcion={fechasRecepcion.mesesRecepcion ?? 0}
            onActualizarFechasRecepcion={handleActualizarFechasRecepcion}
            onCrearCertificado={handleCrearCertificado}
            onActualizarCertificado={handleActualizarCertificado}
            onEliminarCertificado={handleEliminarCertificado}
            onCompletarCertificado={handleCompletarCertificado}
            onAgregarDocumento={handleAgregarDocumento}
            onActualizarDocumento={handleActualizarDocumento}
            onEliminarDocumento={handleEliminarDocumento}
            onToggleDocumentoCompletado={handleToggleDocumentoCompletado}
            onCrearSeccion={handleCrearSeccionRecepcion}
            onEliminarSeccion={handleEliminarSeccionRecepcion}
          />
        )}

        {/* TAB: RECEPCIÓN - RECEPCIÓN OBRA */}
        {activeTab === 'recepcion-obra' && (
          <RecepcionObra
            certificadosObra={certificadosObra}
            mesesRecepcionObra={mesesRecepcionObra}
            fechasRecepcion={fechasRecepcion}
            mesesRecepcion={fechasRecepcion.mesesRecepcion ?? 0}
            onActualizarMesesRecepcionObra={handleActualizarMesesRecepcionObra}
            onCrearCertificadoObra={handleCrearCertificadoObra}
            onAgregarDocumentoObra={handleAgregarDocumentoObra}
            onActualizarDocumentoObra={handleActualizarDocumentoObra}
            onEliminarDocumentoObra={handleEliminarDocumentoObra}
            onToggleDocumentoCompletadoObra={handleToggleDocumentoCompletadoObra}
          />
        )}

        {/* TAB: RECEPCIÓN - PROGRESO */}
        {activeTab === 'recepcion-progreso' && (
          <ProgresoRecepcion
            certificados={certificados}
            completados={certificadosCompletados}
            miembrosEquipo={teamMembers}
          />
        )}

        {/* TAB: RECEPCIÓN - RUTA CRÍTICA */}
        {activeTab === 'recepcion-rutacritica' && (
          <RutaCriticaRecepcion
            certificados={certificados}
            fechasRecepcion={fechasRecepcion}
            projectName={projectName}
          />
        )}

        {/* TAB: PROGRAMA DE OBRA */}
        {activeTab === 'programa-dashboard' && (
          <DashboardPrograma />
        )}
        {activeTab === 'programa' && (
          <MatrizPrograma />
        )}
        {activeTab === 'programa-progreso' && (
          <ProgresoPrograma />
        )}

        {/* TAB: ENTREGA DEPARTAMENTO */}
        {activeTab === 'calidad-dashboard' && <DashboardCalidad />}
        {activeTab === 'calidad-matriz' && <MatrizCalidad />}
        {activeTab === 'calidad-observaciones' && <ObservacionesCalidad />}
        {activeTab === 'calidad-seguimiento' && <SeguimientoCalidad />}
        {activeTab === 'calidad-registros' && <RegistrosCalidad />}

        {/* TAB: AYUDA */}
        {activeTab === 'ayuda' && <TabAyuda />}

        {/* TAB: VISTA GLOBAL MULTI-PROYECTO */}
        {activeTab === 'dashboard-global' && (
          <DashboardGlobal
            onAbrirProyecto={(proyecto) => handleCambiarProyecto(proyecto)}
            onEliminarProyecto={handleEliminarProyecto}
            totalProyectos={proyectos.length}
            usuarioActual={usuarioActual}
          />
        )}

        {/* TAB: PROYECTOS Y EQUIPOS */}
        {activeTab === 'proyectos-equipo' && (
          <TabProyectosEquipo
            onAbrirProyecto={handleCambiarProyecto}
          />
        )}

        {/* TAB: EQUIPO GLOBAL */}
        {activeTab === 'global-equipo' && (
          <TabGlobalEquipo usuarioActual={usuarioActual} />
        )}

        {/* TAB: PANEL DE ADMINISTRACIÓN */}
        {activeTab.startsWith('admin') && (
          <AdminPanel vistaExterna={activeTab.replace('admin-', '')} ocultarSidebar />
        )}

        {/* MODAL: NUEVO PROYECTO */}
        <ModalNuevoProyecto
          visible={showModalNuevoProyecto}
          onCerrar={() => setShowModalNuevoProyecto(false)}
          onCrear={handleCrearProyecto}
        />



        {/* MODAL SUBCONTRATO */}
        <ModalProcesoSubcontrato
          showModal={showModal} selectedTask={selectedTask} selectedStage={selectedStage}
          closeStageModal={closeStageModal} handleFileUpload={handleFileUpload}
          stageFiles={stageFiles} openFileViewer={openFileViewer} downloadFile={downloadFile} removeFile={removeFile}
          processNoAplica={processNoAplica} setProcessNoAplica={setProcessNoAplica}
          stageComments={stageComments} removeComment={removeComment}
          currentComment={currentComment} setCurrentComment={setCurrentComment}
          saveStageData={saveStageData} completedProcesses={completedProcesses}
          revertTaskProcess={revertTaskProcess} isRevertingProcess={isRevertingProcess}
          markProcessComplete={markProcessComplete} isSavingProcess={isSavingProcess}
          teamMembers={teamMembers} projectName={projectName} usuarioActual={usuarioActual}
        />



        {/* MODAL MATERIALES */}
        <ModalProcesoMaterial
          showMaterialModal={showMaterialModal} selectedMaterial={selectedMaterial}
          selectedMaterialStage={selectedMaterialStage}
          closeMaterialStageModal={closeMaterialStageModal}
          handleMaterialFileUpload={handleMaterialFileUpload}
          materialStageFiles={materialStageFiles} setMaterialStageFiles={setMaterialStageFiles}
          materialProcessNoAplica={materialProcessNoAplica} setMaterialProcessNoAplica={setMaterialProcessNoAplica}
          materialStageComments={materialStageComments} setMaterialStageComments={setMaterialStageComments}
          currentMaterialComment={currentMaterialComment} setCurrentMaterialComment={setCurrentMaterialComment}
          saveMaterialStageData={saveMaterialStageData} completedProcessesMateriales={completedProcessesMateriales}
          revertMaterialProcess={revertMaterialProcess} isRevertingMaterialProcess={isRevertingMaterialProcess}
          markMaterialProcessComplete={markMaterialProcessComplete} isSavingMaterialProcess={isSavingMaterialProcess}
          teamMembers={teamMembers} projectName={projectName} usuarioActual={usuarioActual}
        />

        </main>

        {/* Barra de acciones para selección múltiple - Subcontratos */}
        <BarraAccionesSeleccion
          cantidadSeleccionados={subcontratosSeleccionados.size}
          tipo="subcontratos"
          onEliminar={removeSelectedTasks}
          onCancelar={clearAllTaskSelection}
          eliminando={eliminandoSeleccionados}
        />

        {/* Barra de acciones para selección múltiple - Materiales */}
        <BarraAccionesSeleccion
          cantidadSeleccionados={materialesSeleccionados.size}
          tipo="materiales"
          onEliminar={removeSelectedMaterials}
          onCancelar={clearAllMaterialSelection}
          eliminando={eliminandoSeleccionados}
        />
      </div>
    </div>
  );
}

export default App;
